import React from 'react';
// eslint-disable-next-line no-restricted-imports
import {
  Icon as ChakraIcon,
  IconProps as ChakraIconProps,
  CheckIcon,
  CloseIcon,
  DownloadIcon,
  ExternalLinkIcon,
  InfoOutlineIcon,
  LockIcon,
  SearchIcon,
  TriangleDownIcon,
  TriangleUpIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ArrowBackIcon,
  UnlockIcon,
  WarningIcon,
  ChevronUpIcon,
  SettingsIcon,
  ViewIcon,
  DeleteIcon,
  ViewOffIcon,
  InfoIcon,
  ChatIcon,
} from '@chakra-ui/icons';

const MMMIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 12.5H7C6.72386 12.5 6.5 12.7239 6.5 13V18C6.5 18.2761 6.72386 18.5 7 18.5H14.5V12.5ZM7 11C5.89543 11 5 11.8954 5 13V18C5 19.1046 5.89543 20 7 20H16V11H7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 20L9.5 24.5C9.5 24.7761 9.72386 25 10 25L11 25C11.2761 25 11.5 24.7761 11.5 24.5L11.5 20L9.5 20ZM8 24.5C8 25.6046 8.89543 26.5 10 26.5L11 26.5C12.1046 26.5 13 25.6046 13 24.5L13 18.5L8 18.5L8 24.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8125 14.5H3.25C2.93934 14.5 2.6875 14.7239 2.6875 15V16C2.6875 16.2761 2.93934 16.5 3.25 16.5H4.8125V14.5ZM3.25 13C2.00736 13 1 13.8954 1 15V16C1 17.1046 2.00736 18 3.25 18H6.5V13H3.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11.8904V19.1095L24 23.4732V7.52679L16 11.8904ZM14.5 20L24.0211 25.1933C24.6875 25.5568 25.5 25.0745 25.5 24.3154V6.68452C25.5 5.92546 24.6875 5.44315 24.0211 5.80662L14.5 11V20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5 13.5V17.5C26.6046 17.5 27.5 16.6046 27.5 15.5C27.5 14.3954 26.6046 13.5 25.5 13.5ZM25.5 12H24V19H25.5C27.433 19 29 17.433 29 15.5C29 13.567 27.433 12 25.5 12Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const OverviewIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        d="M17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 19.5C17.933 19.5 19.5 17.933 19.5 16C19.5 14.067 17.933 12.5 16 12.5C14.067 12.5 12.5 14.067 12.5 16C12.5 17.933 14.067 19.5 16 19.5ZM16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0425 15.7003C28.042 15.7015 28.0415 15.7028 28.0408 15.7043C28.0468 15.6859 28.0491 15.6837 28.0425 15.7003ZM27.877 16C27.7564 15.8077 27.5809 15.5594 27.3466 15.268C26.7764 14.5587 25.9192 13.6697 24.8205 12.8023C22.6126 11.0592 19.5564 9.5 16 9.5C12.4436 9.5 9.38744 11.0592 7.17947 12.8023C6.0808 13.6697 5.22361 14.5587 4.65344 15.268C4.41911 15.5594 4.24363 15.8077 4.12298 16C4.24363 16.1923 4.41911 16.4406 4.65344 16.732C5.22361 17.4413 6.0808 18.3303 7.17947 19.1977C9.38744 20.9408 12.4436 22.5 16 22.5C19.5564 22.5 22.6126 20.9408 24.8205 19.1977C25.9192 18.3303 26.7764 17.4413 27.3466 16.732C27.5809 16.4406 27.7564 16.1923 27.877 16ZM3.95754 15.7003C3.95094 15.6837 3.95315 15.6859 3.95913 15.7042C3.95852 15.7028 3.95799 15.7015 3.95754 15.7003ZM3.95754 16.2997C3.958 16.2985 3.95854 16.2972 3.95917 16.2957C3.95316 16.3141 3.95092 16.3163 3.95754 16.2997ZM28.0408 16.2957C28.0415 16.2972 28.042 16.2985 28.0425 16.2997C28.0491 16.3163 28.0468 16.3141 28.0408 16.2957ZM16 24C24 24 29.5 17 29.5 16C29.5 15 24 8 16 8C8 8 2.5 15 2.5 16C2.5 17 8 24 16 24Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const MMMPerformanceIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.17836 24.8184H10.4361C10.8503 24.8184 11.1861 25.1542 11.1861 25.5684C11.1861 25.9827 10.8503 26.3184 10.4361 26.3184H4.40251C4.11893 26.3184 3.85961 26.1585 3.73232 25.9051C2.76447 23.9784 2.21997 21.8028 2.21997 19.5022C2.21997 11.6144 8.61436 5.21997 16.5022 5.21997C24.3901 5.21997 30.7845 11.6144 30.7845 19.5022C30.7845 21.8028 30.24 23.9784 29.2722 25.9051C29.1449 26.1585 28.8856 26.3184 28.602 26.3184H22.5684C22.1542 26.3184 21.8184 25.9827 21.8184 25.5684C21.8184 25.1542 22.1542 24.8184 22.5684 24.8184H23.8261C24.9116 23.3259 25.5515 21.4897 25.5515 19.5022C25.5515 16.6202 24.205 14.053 22.1038 12.3946C20.5629 11.1784 18.6183 10.453 16.5022 10.453C14.3862 10.453 12.4416 11.1784 10.9007 12.3946C9.1193 13.8006 7.88063 15.86 7.54469 18.2086C7.48431 18.6307 7.45301 19.0626 7.45301 19.5022C7.45301 21.4897 8.09291 23.3259 9.17836 24.8184ZM15.7522 6.74161C13.2399 6.88697 10.9221 7.75796 9.00542 9.14814L10.5322 10.8038C12.0366 9.76939 13.8234 9.11488 15.7522 8.97929V6.74161ZM7.84278 10.1C5.80736 11.9756 4.38246 14.5037 3.89999 17.3524H6.17239C6.62784 15.1533 7.76722 13.2058 9.35661 11.7416L7.84278 10.1ZM3.73621 18.8524C3.72543 19.0676 3.71997 19.2843 3.71997 19.5022C3.71997 21.4005 4.13329 23.2004 4.87431 24.8184H7.38865C6.47615 23.2572 5.95301 21.4402 5.95301 19.5022C5.95301 19.2841 5.95965 19.0674 5.97273 18.8524H3.73621ZM25.6158 24.8184H28.1302C28.8712 23.2004 29.2845 21.4005 29.2845 19.5022C29.2845 19.2843 29.2791 19.0676 29.2683 18.8523H27.0318C27.0449 19.0673 27.0515 19.284 27.0515 19.5022C27.0515 21.4402 26.5283 23.2572 25.6158 24.8184ZM26.8322 17.3523H29.1045C28.6368 14.5908 27.2834 12.1306 25.3468 10.274L23.6975 11.7877C25.2612 13.2468 26.3816 15.177 26.8322 17.3523ZM24.1962 9.29401C22.2423 7.81899 19.8514 6.89199 17.2522 6.74161V8.97929C19.2003 9.11624 21.0035 9.7825 22.5173 10.8348L24.1962 9.29401Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9731 13.8506C19.6113 13.6417 19.2155 13.6281 18.88 13.6811C18.5436 13.7343 18.2032 13.8634 17.8816 14.0223C17.2371 14.3406 16.5408 14.8422 15.8908 15.3871C14.6046 16.4651 13.3285 17.8594 12.8505 18.6873C11.8149 20.4809 12.4295 22.7743 14.2231 23.8099C16.0167 24.8454 18.3101 24.2309 19.3457 22.4373C19.8237 21.6094 20.393 19.8071 20.6836 18.1542C20.8304 17.3188 20.9167 16.465 20.8701 15.7477C20.8468 15.3897 20.7885 15.0304 20.6663 14.7125C20.5445 14.3954 20.3349 14.0595 19.9731 13.8506ZM14.1495 19.4373C14.4999 18.8303 15.6233 17.5685 16.8543 16.5367C17.4628 16.0266 18.0545 15.6098 18.5458 15.3672C18.792 15.2456 18.9815 15.1837 19.1141 15.1628C19.1667 15.1545 19.2005 15.154 19.2199 15.1551C19.2306 15.1714 19.2471 15.2009 19.2662 15.2506C19.3143 15.3759 19.3554 15.5709 19.3732 15.8449C19.4088 16.3917 19.3437 17.1125 19.2062 17.8945C18.9281 19.4765 18.397 21.0803 18.0466 21.6873C17.4253 22.7634 16.0492 23.1322 14.9731 22.5108C13.8969 21.8895 13.5282 20.5134 14.1495 19.4373Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const MMMCreatedValueIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.1893 1.25H23.8106L28.539 5.97836L16 19.6077L3.46094 5.97836L8.1893 1.25ZM8.41882 3.14181L9.99996 5.25H6.31062L8.41882 3.14181ZM6.20908 6.75H10.9728L14.0353 15.2567L6.20908 6.75ZM17.9647 15.2567L25.7908 6.75H21.0271L17.9647 15.2567ZM22 5.25H25.6893L23.5811 3.14181L22 5.25ZM22 2.75H17.9726L20.389 4.89792L22 2.75ZM18.5273 5.25L16 3.00347L13.4726 5.25H18.5273ZM12.5671 6.75H19.4328L16 16.2858L12.5671 6.75ZM11.6109 4.89792L14.0273 2.75H9.99996L11.6109 4.89792Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 28.5V23C6.5 22.7239 6.27614 22.5 6 22.5C5.72386 22.5 5.5 22.7239 5.5 23V28C5.5 28.2761 5.72386 28.5 6 28.5H6.5ZM6 21C4.89543 21 4 21.8954 4 23V28C4 29.1046 4.89543 30 6 30H8V23C8 21.8954 7.10457 21 6 21Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7105 25H15V23.5H27.7105C28.5608 23.5 29.25 24.1892 29.25 25.0395C29.25 27.7791 27.0291 30 24.2895 30H6.75V23.75H8.25V28.5H24.2895C26.2007 28.5 27.75 26.9507 27.75 25.0395C27.75 25.0177 27.7323 25 27.7105 25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.76025 24.8767C7.10906 22.7839 8.91976 21.25 11.0414 21.25H18C19.5188 21.25 20.75 22.4812 20.75 24V25H19.25V24C19.25 23.3096 18.6904 22.75 18 22.75H11.0414C9.65301 22.75 8.4681 23.7538 8.23984 25.1233L6.76025 24.8767Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const MMMCostPerUnitIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 22.5V28.5H6.5V22.5H4.5ZM4 21C3.44772 21 3 21.4477 3 22V30H8V22C8 21.4477 7.55228 21 7 21H4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 19.5V28.5H13.5V19.5H11.5ZM11 18C10.4477 18 10 18.4477 10 19V30H15V19C15 18.4477 14.5523 18 14 18H11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 19.5V28.5H20.5V19.5H18.5ZM18 18C17.4477 18 17 18.4477 17 19V30H22V19C22 18.4477 21.5523 18 21 18H18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5 12.5V28.5H27.5V12.5H25.5ZM25 11C24.4477 11 24 11.4477 24 12V30H29V12C29 11.4477 28.5523 11 28 11H25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 29.5C1.25 29.0858 1.58579 28.75 2 28.75H30C30.4142 28.75 30.75 29.0858 30.75 29.5C30.75 29.9142 30.4142 30.25 30 30.25H2C1.58579 30.25 1.25 29.9142 1.25 29.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.0001 3.5H26.5001C26.9143 3.5 27.2501 3.83579 27.2501 4.25V7.75H25.7501V6.06066L17.0304 14.7803C16.8897 14.921 16.699 15 16.5001 15H8.81072L6.03039 17.7803L4.96973 16.7197L7.96973 13.7197C8.11038 13.579 8.30114 13.5 8.50006 13.5H16.1894L24.6894 5H23.0001V3.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10.5C14.7091 10.5 16.5 8.70914 16.5 6.5C16.5 4.29086 14.7091 2.5 12.5 2.5C10.2909 2.5 8.5 4.29086 8.5 6.5C8.5 8.70914 10.2909 10.5 12.5 10.5ZM12.5 12C15.5376 12 18 9.53757 18 6.5C18 3.46243 15.5376 1 12.5 1C9.46243 1 7 3.46243 7 6.5C7 9.53757 9.46243 12 12.5 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 5.5C14 5.20333 13.912 4.91332 13.7472 4.66665C13.7081 4.60813 13.6651 4.55268 13.6186 4.50062C13.469 4.33319 13.2831 4.20078 13.074 4.11418C13.0498 4.10413 13.0253 4.09474 13.0006 4.08601C12.7466 3.99608 12.4726 3.97607 12.2074 4.02882C11.9164 4.0867 11.6491 4.22956 11.4393 4.43934C11.2296 4.64912 11.0867 4.91639 11.0288 5.20737C10.9761 5.47258 10.9961 5.74662 11.086 6.00062C11.0947 6.02529 11.1041 6.04976 11.1142 6.07403C11.2008 6.2831 11.3332 6.469 11.5006 6.61859C11.5527 6.6651 11.6081 6.70811 11.6666 6.74721C11.9133 6.91203 12.2033 7 12.5 7V6.00062C12.4339 6.00062 12.3689 5.98755 12.3084 5.96251C12.2783 5.95002 12.2493 5.93456 12.2219 5.91625C12.1669 5.87955 12.1201 5.83253 12.0838 5.77813C12.0656 5.75099 12.0501 5.72202 12.0375 5.69158C12.0122 5.63055 11.9994 5.56543 11.9994 5.5C11.9994 5.46737 12.0026 5.43465 12.009 5.40234C12.0283 5.30522 12.076 5.21602 12.146 5.14601C12.216 5.076 12.3052 5.02832 12.4023 5.009C12.4347 5.00257 12.4674 4.99938 12.5 4.99938C12.5654 4.99938 12.6305 5.01221 12.6916 5.03749C12.722 5.0501 12.751 5.06562 12.7781 5.08375C12.8325 5.1201 12.8795 5.16694 12.9162 5.22187C12.9346 5.24927 12.95 5.27827 12.9625 5.30842C12.9875 5.36887 13.0006 5.43394 13.0006 5.5H14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7.5C11 7.79667 11.088 8.08668 11.2528 8.33335C11.2921 8.39212 11.3353 8.44779 11.382 8.50005C11.5315 8.66716 11.7172 8.79933 11.926 8.88582C11.9505 8.89596 11.9752 8.90543 12 8.91423C12.2539 9.00396 12.5277 9.02389 12.7926 8.97118C13.0836 8.9133 13.3509 8.77044 13.5607 8.56066C13.7704 8.35088 13.9133 8.08361 13.9712 7.79263C14.0239 7.52765 14.004 7.25386 13.9142 7.00005C13.9054 6.97516 13.896 6.95046 13.8858 6.92597C13.7993 6.71718 13.6672 6.53149 13.5 6.38201C13.4478 6.33526 13.3921 6.29206 13.3334 6.25279C13.0867 6.08797 12.7967 6 12.5 6L12.5 7.00005C12.566 7.00005 12.631 7.0131 12.6913 7.03811C12.7214 7.05058 12.7504 7.06602 12.7778 7.08431C12.8326 7.12096 12.8794 7.16791 12.9157 7.22224C12.9338 7.24934 12.9493 7.27827 12.9619 7.30868C12.9871 7.36963 12.9999 7.43466 12.9999 7.5C12.9999 7.53259 12.9968 7.56526 12.9903 7.59753C12.9711 7.69452 12.9234 7.7836 12.8535 7.85352C12.7836 7.92344 12.6945 7.97105 12.5975 7.99034C12.5653 7.99676 12.5326 7.99995 12.5 7.99995C12.4347 7.99995 12.3696 7.98714 12.3087 7.96189C12.2783 7.9493 12.2493 7.9338 12.2222 7.91569C12.1679 7.87939 12.121 7.83261 12.0843 7.77776C12.066 7.75039 12.0506 7.72143 12.0381 7.69132C12.0131 7.63096 12 7.56597 12 7.5L11 7.5Z"
        fill="currentColor"
      />
      <path d="M12 3.5H13V4.5H12V3.5Z" fill="currentColor" />
      <path d="M12 8.5H13V9.5H12V8.5Z" fill="currentColor" />
    </ChakraIcon>
  );
};

const MMMModellingIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 22.5V28.5H6.5V22.5H4.5ZM4 21C3.44772 21 3 21.4477 3 22V30H8V22C8 21.4477 7.55228 21 7 21H4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 19.5V28.5H13.5V19.5H11.5ZM11 18C10.4477 18 10 18.4477 10 19V30H15V19C15 18.4477 14.5523 18 14 18H11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 19.5V28.5H20.5V19.5H18.5ZM18 18C17.4477 18 17 18.4477 17 19V30H22V19C22 18.4477 21.5523 18 21 18H18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5 12.5V28.5H27.5V12.5H25.5ZM25 11C24.4477 11 24 11.4477 24 12V30H29V12C29 11.4477 28.5523 11 28 11H25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 29.25C1.25 28.8358 1.58579 28.5 2 28.5H30C30.4142 28.5 30.75 28.8358 30.75 29.25C30.75 29.6642 30.4142 30 30 30H2C1.58579 30 1.25 29.6642 1.25 29.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 17C6.32843 17 7 16.3284 7 15.5C7 14.6716 6.32843 14 5.5 14C4.67157 14 4 14.6716 4 15.5C4 16.3284 4.67157 17 5.5 17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 14C13.3284 14 14 13.3284 14 12.5C14 11.6716 13.3284 11 12.5 11C11.6716 11 11 11.6716 11 12.5C11 13.3284 11.6716 14 12.5 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 14C20.3284 14 21 13.3284 21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5C18 13.3284 18.6716 14 19.5 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5 7C27.3284 7 28 6.32843 28 5.5C28 4.67157 27.3284 4 26.5 4C25.6716 4 25 4.67157 25 5.5C25 6.32843 25.6716 7 26.5 7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7785 13.6963L6.77852 15.6963L6.22144 14.3036L11.2214 12.3036L11.7785 13.6963Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 13.25H13.5V11.75H18.5V13.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5304 6.53039L21.0304 12.0304L19.9697 10.9697L25.4697 5.46973L26.5304 6.53039Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const AiIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 49 48" fill="none" {...props}>
    {/* swap stroke="currentColor" → stroke="currentColor" */}
    <circle cx="12.3335" cy="16" r="3" stroke="currentColor" strokeWidth="2" />
    <circle cx="24.3335" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
    <circle cx="36.3335" cy="20" r="3" stroke="currentColor" strokeWidth="2" />
    <path
      d="M28.3335 44V35.5M24.3335 13V22.3787C24.3335 22.7765 24.4915 23.158 24.7728 23.4393L27.8942 26.5607C28.1755 26.842 28.3335 27.2235 28.3335 27.6213V35.5M28.3335 35.5L35.8594 28.4445C36.1619 28.1609 36.3335 27.7648 36.3335 27.3502V23M18.3335 40V32.6213C18.3335 32.2235 18.1755 31.842 17.8942 31.5607L12.7728 26.4393C12.4915 26.158 12.3335 25.7765 12.3335 25.3787V19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const LocationIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 49 48" fill="none" {...props}>
    {/* swap stroke="currentColor" → stroke="currentColor" */}
    <path
      d="M24.6667 5C32.428 5 38.6667 11.0937 38.6667 18.5459C38.6666 19.9991 38.0897 21.9199 37.0759 24.1289C36.0733 26.3137 34.691 28.6795 33.1863 30.9912C30.1778 35.6132 26.7323 39.9392 25.0056 42.0371C24.8228 42.2587 24.5106 42.2587 24.3279 42.0371C22.6012 39.9392 19.1557 35.6132 16.1472 30.9912C14.6425 28.6795 13.2602 26.3137 12.2576 24.1289C11.2438 21.9199 10.6669 19.9991 10.6667 18.5459C10.6667 11.0937 16.9055 5 24.6667 5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="24.6667" cy="16" r="5" stroke="currentColor" strokeWidth="2" />
  </ChakraIcon>
);

const GearIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 49 48" fill="none" {...props}>
    <g clipPath="url(#clip0_1_501)">
      <path
        d="M28.784 5.6362C28.6171 4.96845 28.0171 4.5 27.3288 4.5H20.6711C19.9828 4.5 19.3828 4.96845 19.2159 5.6362L18.2247 9.60098C18.1262 9.99503 17.8721 10.3323 17.5205 10.5356L15.5834 11.6559C15.2311 11.8597 14.8112 11.9116 14.4199 11.7996L10.4885 10.675C9.82673 10.4857 9.12106 10.7711 8.77691 11.3672L5.44807 17.1329C5.10392 17.729 5.20962 18.4828 5.70444 18.9612L8.6441 21.8036C8.93638 22.0862 9.10143 22.4754 9.10143 22.882L9.10143 25.1181C9.10143 25.5246 8.93639 25.9138 8.6441 26.1964L5.70444 29.0388C5.20962 29.5173 5.10392 30.2711 5.44807 30.8672L8.77691 36.6329C9.12106 37.229 9.82673 37.5143 10.4885 37.325L14.4023 36.2054C14.8039 36.0906 15.2352 36.1483 15.5924 36.3649L17.0376 37.241C17.3418 37.4254 17.5706 37.7119 17.6831 38.0493L19.1581 42.4743C19.3622 43.0869 19.9354 43.5 20.5811 43.5H27.4188C28.0644 43.5 28.6377 43.0869 28.8418 42.4743L30.3153 38.054C30.4287 37.7137 30.6603 37.4253 30.9681 37.2412L32.441 36.3597C32.7975 36.1464 33.2266 36.0905 33.6259 36.2054L37.5102 37.3228C38.1725 37.5134 38.8794 37.2281 39.224 36.6313L42.5561 30.8599C42.8983 30.2672 42.7959 29.518 42.3072 29.0388L39.4072 26.1953C39.1195 25.9132 38.9574 25.5272 38.9574 25.1242V22.8758C38.9574 22.4729 39.1195 22.0869 39.4072 21.8047L42.3072 18.9612C42.7959 18.482 42.8983 17.7329 42.5561 17.1402L39.224 11.3687C38.8794 10.7719 38.1725 10.4867 37.5102 10.6772L33.6093 11.7995C33.2198 11.9115 32.8014 11.8612 32.4496 11.6598L30.4844 10.5351C30.1298 10.3322 29.8733 9.99342 29.7742 9.59706L28.784 5.6362Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M31.4999 24C31.4999 28.1421 28.1421 31.5 23.9999 31.5C19.8578 31.5 16.4999 28.1421 16.4999 24C16.4999 19.8579 19.8578 16.5 23.9999 16.5C28.1421 16.5 31.4999 19.8579 31.4999 24Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_501">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const DAIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.75 3.75C7.75 2.23122 8.98122 1 10.5 1H21.5C23.0188 1 24.25 2.23122 24.25 3.75V9.75H22.75V3.75C22.75 3.05964 22.1904 2.5 21.5 2.5H10.5C9.80964 2.5 9.25 3.05964 9.25 3.75V27.75C9.25 28.4404 9.80964 29 10.5 29H21.5C22.1904 29 22.75 28.4404 22.75 27.75V21.75H24.25V27.75C24.25 29.2688 23.0188 30.5 21.5 30.5H10.5C8.98122 30.5 7.75 29.2688 7.75 27.75V3.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 2.5H12.5V3C12.5 3.27614 12.7239 3.5 13 3.5H19C19.2761 3.5 19.5 3.27614 19.5 3V2.5ZM11 1V3C11 4.10457 11.8954 5 13 5H19C20.1046 5 21 4.10457 21 3V1H11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 24C16.8284 24 17.5 23.3284 17.5 22.5C17.5 21.6716 16.8284 21 16 21C15.1716 21 14.5 21.6716 14.5 22.5C14.5 23.3284 15.1716 24 16 24Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C12.8284 21 13.5 20.3284 13.5 19.5C13.5 18.6716 12.8284 18 12 18C11.1716 18 10.5 18.6716 10.5 19.5C10.5 20.3284 11.1716 21 12 21Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14C12.8284 14 13.5 13.3284 13.5 12.5C13.5 11.6716 12.8284 11 12 11C11.1716 11 10.5 11.6716 10.5 12.5C10.5 13.3284 11.1716 14 12 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.213 10.8071C22.4932 10.691 22.8158 10.7552 23.0303 10.9697L27.5303 15.4697C27.8232 15.7626 27.8232 16.2375 27.5303 16.5304L23.0303 21.0304C22.8158 21.2449 22.4932 21.309 22.213 21.1929C21.9327 21.0768 21.75 20.8034 21.75 20.5V18.25H17.3107L15.5303 20.0304C15.3897 20.171 15.1989 20.25 15 20.25H13V18.75H14.6893L16.4697 16.9697C16.6103 16.829 16.8011 16.75 17 16.75H22.5C22.9142 16.75 23.25 17.0858 23.25 17.5V18.6894L25.9393 16L23.25 13.3107V14.5C23.25 14.9142 22.9142 15.25 22.5 15.25H17C16.8011 15.25 16.6103 15.171 16.4697 15.0304L14.6893 13.25H13V11.75H15C15.1989 11.75 15.3897 11.829 15.5303 11.9697L17.3107 13.75H21.75V11.5C21.75 11.1967 21.9327 10.9232 22.213 10.8071Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4697 9.96967C16.7626 9.67678 17.2374 9.67678 17.5303 9.96967L18.8107 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H18.5C18.3011 12.75 18.1103 12.671 17.9697 12.5303L16.4697 11.0303C16.1768 10.7374 16.1768 10.2626 16.4697 9.96967Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4697 22.0303C16.7626 22.3232 17.2374 22.3232 17.5303 22.0303L18.8107 20.75H20C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25H18.5C18.3011 19.25 18.1103 19.329 17.9697 19.4697L16.4697 20.9697C16.1768 21.2626 16.1768 21.7374 16.4697 22.0303Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const DAExplorerIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 28.5C22.9036 28.5 28.5 22.9036 28.5 16C28.5 9.09644 22.9036 3.5 16 3.5C9.09644 3.5 3.5 9.09644 3.5 16C3.5 22.9036 9.09644 28.5 16 28.5ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
        fill="currentColor"
      />
      <path
        d="M17 26C17 26.5523 16.5523 27 16 27C15.4477 27 15 26.5523 15 26C15 25.4477 15.4477 25 16 25C16.5523 25 17 25.4477 17 26Z"
        fill="currentColor"
      />
      <path
        d="M7 16C7 16.5523 6.55228 17 6 17C5.44772 17 5 16.5523 5 16C5 15.4477 5.44772 15 6 15C6.55228 15 7 15.4477 7 16Z"
        fill="currentColor"
      />
      <path
        d="M27 16C27 16.5523 26.5523 17 26 17C25.4477 17 25 16.5523 25 16C25 15.4477 25.4477 15 26 15C26.5523 15 27 15.4477 27 16Z"
        fill="currentColor"
      />
      <path
        d="M17 6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6C15 5.44772 15.4477 5 16 5C16.5523 5 17 5.44772 17 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1859 13.1859L10.3718 21.6283L18.8142 18.8142L21.6283 10.3718L13.1859 13.1859ZM12.4744 11.8419C12.1758 11.9415 11.9415 12.1758 11.8419 12.4744L8.63251 22.1027C8.37193 22.8844 9.11567 23.6282 9.89742 23.3676L19.5257 20.1582C19.8243 20.0586 20.0586 19.8243 20.1582 19.5257L23.3676 9.89742C23.6282 9.11567 22.8844 8.37193 22.1027 8.63251L12.4744 11.8419Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const DADeepDiveIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 5.5H5C4.72386 5.5 4.5 5.72386 4.5 6V22C4.5 22.2761 4.72386 22.5 5 22.5H9.25C10.2165 22.5 11 23.2835 11 24.25V24.8884L14.2771 22.9768C14.8124 22.6645 15.421 22.5 16.0407 22.5H27C27.2761 22.5 27.5 22.2761 27.5 22V6C27.5 5.72386 27.2761 5.5 27 5.5ZM15.033 24.2724C15.3388 24.094 15.6866 24 16.0407 24H27C28.1046 24 29 23.1046 29 22V6C29 4.89543 28.1046 4 27 4H5C3.89543 4 3 4.89543 3 6V22C3 23.1046 3.89543 24 5 24H9.25C9.38807 24 9.5 24.1119 9.5 24.25V27.0647C9.5 27.2577 9.7093 27.3779 9.87597 27.2807L15.033 24.2724Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 14L14 12.2679L14 15.732L17 14ZM18.5 14.866C19.1667 14.4811 19.1667 13.5188 18.5 13.1339L14 10.5359C13.3333 10.151 12.5 10.6321 12.5 11.4019L12.5 16.598C12.5 17.3678 13.3333 17.849 14 17.4641L18.5 14.866Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 7.75C6.25 7.33579 6.58579 7 7 7H25C25.4142 7 25.75 7.33579 25.75 7.75C25.75 8.16421 25.4142 8.5 25 8.5H7C6.58579 8.5 6.25 8.16421 6.25 7.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 20.25C6.25 19.8358 6.58579 19.5 7 19.5H25C25.4142 19.5 25.75 19.8358 25.75 20.25C25.75 20.6642 25.4142 21 25 21H7C6.58579 21 6.25 20.6642 6.25 20.25Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const DAChannelsIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 28.5C22.9036 28.5 28.5 22.9036 28.5 16C28.5 9.09644 22.9036 3.5 16 3.5C9.09644 3.5 3.5 9.09644 3.5 16C3.5 22.9036 9.09644 28.5 16 28.5ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.00292 23.5039C7.33781 25.2823 9.12917 26.6802 11.199 27.5413C13.7337 28.5956 16.5449 28.7863 19.1987 28.0838C21.8525 27.3813 24.2012 25.8248 25.8823 23.6545C27.2551 21.8822 28.1202 19.7811 28.4004 17.5751L16.3977 17.5024L6.00292 23.5039ZM4.69545 24.2588C4.40095 23.8556 4.12715 23.4356 3.87567 23L16 16L29.9998 16.0848C29.9998 16.0852 29.9998 16.0857 29.9998 16.0862C29.9967 16.5887 29.9666 17.0887 29.9101 17.5843C29.6213 20.1205 28.6429 22.5399 27.0682 24.573C25.1854 27.0038 22.5548 28.7471 19.5825 29.5339C16.6103 30.3207 13.4617 30.1071 10.6229 28.9262C8.24848 27.9385 6.20125 26.3199 4.69545 24.2588Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.0438 7.01652L16.5438 17.0165L15.4563 15.9834L24.9563 5.9834L26.0438 7.01652Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.75 2.5V16.5H15.25V2.5H16.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </ChakraIcon>
  );
};

const DASearchIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 18.5C15.1421 18.5 18.5 15.1421 18.5 11C18.5 6.85786 15.1421 3.5 11 3.5C6.85786 3.5 3.5 6.85786 3.5 11C3.5 15.1421 6.85786 18.5 11 18.5ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 6.5C9.97471 6.5 9.45457 6.60346 8.96927 6.80448C8.48396 7.0055 8.04301 7.30014 7.67157 7.67157C7.30014 8.04301 7.0055 8.48396 6.80448 8.96927C6.60346 9.45457 6.5 9.97471 6.5 10.5L5 10.5C5 9.77773 5.14226 9.06253 5.41866 8.39524C5.69506 7.72795 6.10019 7.12164 6.61091 6.61091C7.12163 6.10019 7.72795 5.69506 8.39524 5.41866C9.06253 5.14226 9.77773 5 10.5 5V6.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5304 17.591L21.6146 22.6751C21.9075 22.968 22.3823 22.968 22.6752 22.6751C22.9681 22.3822 22.9681 21.9074 22.6752 21.6145L17.591 16.5303L18.6517 15.4696L23.7359 20.5538C24.6146 21.4325 24.6146 22.8571 23.7359 23.7358C22.8572 24.6145 21.4326 24.6145 20.5539 23.7358L15.4697 18.6516L16.5304 17.591Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 8.75H22V7.25H27C28.5188 7.25 29.75 8.48122 29.75 10V26C29.75 27.5188 28.5188 28.75 27 28.75H5C3.48122 28.75 2.25 27.5188 2.25 26V21.5H3.75V26C3.75 26.6904 4.30964 27.25 5 27.25H27C27.6904 27.25 28.25 26.6904 28.25 26V10C28.25 9.30964 27.6904 8.75 27 8.75Z"
        fill="currentColor"
      />
      <path d="M6 25.25H16" stroke="black" strokeWidth="1.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 23H6V21.5H14V23Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const MOIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 22.5V28.5H6.5V22.5H4.5ZM4 21C3.44772 21 3 21.4477 3 22V30H8V22C8 21.4477 7.55228 21 7 21H4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 19.5V28.5H13.5V19.5H11.5ZM11 18C10.4477 18 10 18.4477 10 19V30H15V19C15 18.4477 14.5523 18 14 18H11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 19.5V28.5H20.5V19.5H18.5ZM18 18C17.4477 18 17 18.4477 17 19V30H22V19C22 18.4477 21.5523 18 21 18H18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5 12.5V28.5H27.5V12.5H25.5ZM25 11C24.4477 11 24 11.4477 24 12V30H29V12C29 11.4477 28.5523 11 28 11H25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 29.25C1.25 28.8358 1.58579 28.5 2 28.5H30C30.4142 28.5 30.75 28.8358 30.75 29.25C30.75 29.6642 30.4142 30 30 30H2C1.58579 30 1.25 29.6642 1.25 29.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 9.5C12.0523 9.5 12.5 9.05228 12.5 8.5C12.5 7.94772 12.0523 7.5 11.5 7.5C10.9477 7.5 10.5 7.94772 10.5 8.5C10.5 9.05228 10.9477 9.5 11.5 9.5ZM11.5 11C12.8807 11 14 9.88071 14 8.5C14 7.11929 12.8807 6 11.5 6C10.1193 6 9 7.11929 9 8.5C9 9.88071 10.1193 11 11.5 11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3541 8.5C18.3031 8.42258 18.2427 8.33553 18.1723 8.23992C17.8341 7.78055 17.32 7.19773 16.6595 6.62832C15.3227 5.47597 13.5329 4.5 11.5 4.5C9.46706 4.5 7.67728 5.47597 6.3405 6.62832C5.67996 7.19773 5.16593 7.78055 4.82772 8.23992C4.75733 8.33553 4.69692 8.42257 4.64593 8.5C4.69692 8.57743 4.75733 8.66447 4.82772 8.76008C5.16593 9.21945 5.67996 9.80227 6.3405 10.3717C7.67728 11.524 9.46706 12.5 11.5 12.5C13.5329 12.5 15.3227 11.524 16.6595 10.3717C17.32 9.80227 17.8341 9.21945 18.1723 8.76008C18.2427 8.66447 18.3031 8.57743 18.3541 8.5ZM11.5 14C16.537 14 20 9.1875 20 8.5C20 7.8125 16.537 3 11.5 3C6.46296 3 3 7.8125 3 8.5C3 9.1875 6.46296 14 11.5 14Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const LtIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8071 8.53701C10.691 8.25676 10.7552 7.93417 10.9697 7.71967L15.4697 3.21967C15.7626 2.92678 16.2375 2.92678 16.5304 3.21967L21.0304 7.71967C21.2449 7.93417 21.309 8.25676 21.1929 8.53701C21.0768 8.81727 20.8034 9 20.5 9L18.25 9L18.25 13.4393L20.0304 15.2197C20.171 15.3603 20.25 15.5511 20.25 15.75L20.25 17.75L18.75 17.75L18.75 16.0607L16.9697 14.2803C16.829 14.1397 16.75 13.9489 16.75 13.75L16.75 8.25C16.75 7.83579 17.0858 7.5 17.5 7.5L18.6894 7.5L16 4.81066L13.3107 7.5L14.5 7.5C14.9142 7.5 15.25 7.83579 15.25 8.25L15.25 13.75C15.25 13.9489 15.171 14.1397 15.0304 14.2803L13.25 16.0607L13.25 17.75L11.75 17.75L11.75 15.75C11.75 15.5511 11.829 15.3603 11.9697 15.2197L13.75 13.4393L13.75 9L11.5 9C11.1967 9 10.9232 8.81727 10.8071 8.53701Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 23.25C8.25 22.8358 8.58579 22.5 9 22.5H23C23.4142 22.5 23.75 22.8358 23.75 23.25C23.75 23.6642 23.4142 24 23 24H9C8.58579 24 8.25 23.6642 8.25 23.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 9C4.80964 9 4.25 9.55964 4.25 10.25V24.25C4.25 24.9404 4.80964 25.5 5.5 25.5H26.5C27.1904 25.5 27.75 24.9404 27.75 24.25V10.25C27.75 9.55964 27.1904 9 26.5 9H22.25V7.5H26.5C28.0188 7.5 29.25 8.73122 29.25 10.25V24.25C29.25 25.7688 28.0188 27 26.5 27H5.5C3.98122 27 2.75 25.7688 2.75 24.25V10.25C2.75 8.73122 3.98122 7.5 5.5 7.5H9.75V9H5.5Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const SOSIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.88,18.47c0.44-0.7,0.7-1.51,0.7-2.39c0-2.49-2.01-4.5-4.5-4.5s-4.5,2.01-4.5,4.5s2.01,4.5,4.49,4.5 c0.88,0,1.7-0.26,2.39-0.7L21.58,23L23,21.58L19.88,18.47z M16.08,18.58c-1.38,0-2.5-1.12-2.5-2.5c0-1.38,1.12-2.5,2.5-2.5 s2.5,1.12,2.5,2.5C18.58,17.46,17.46,18.58,16.08,18.58z M15.72,10.08c-0.74,0.02-1.45,0.18-2.1,0.45l-0.55-0.83l-3.8,6.18 l-3.01-3.52l-3.63,5.81L1,17l5-8l3,3.5L13,6C13,6,15.72,10.08,15.72,10.08z M18.31,10.58c-0.64-0.28-1.33-0.45-2.05-0.49 c0,0,5.12-8.09,5.12-8.09L23,3.18L18.31,10.58z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const SOSMunicipalityIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const AiDocIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      d="M40.9688 32.8125V46.125"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6263 46.125H12.293C9.18637 46.125 6.66797 43.6066 6.66797 40.5V7.5C6.66797 4.39341 9.18637 1.875 12.293 1.875H29.9481C30.9426 1.875 31.8964 2.27007 32.5997 2.97338L39.8717 10.2454C40.575 10.9487 40.9701 11.9025 40.9701 12.897V25.2188"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.4209 41.625H25.291"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M25.125 46.125V37.0313C25.125 34.7013 27.0138 32.8125 29.3438 32.8125C31.6737 32.8125 33.5625 34.7013 33.5625 37.0313V46.125"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </ChakraIcon>
);

const FiltersIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 36 36" {...props}>
      <path
        d="M6 31.5V21M6 15V4.5M18 31.5V18M18 12V4.5M30 31.5V24M30 18V4.5M3 21H9M15 12H21M27 24H33"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </ChakraIcon>
  );
};

const CircleCheckbox: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const GraphIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M3 3V21H21"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 9L14 14L10 10L7 13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const GrowthIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 48 48" fill="none" {...props}>
    <g clipPath="url(#clip0_2015_4334)">
      <path
        d="M5.25 46.125V37.625C5.25 36.5204 6.14543 35.625 7.25 35.625H10.75C11.8546 35.625 12.75 36.5204 12.75 37.625V46.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25 46.125V30.125C20.25 29.0204 21.1454 28.125 22.25 28.125H25.75C26.8546 28.125 27.75 29.0204 27.75 30.125V46.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.25 46.125V22.625C35.25 21.5204 36.1454 20.625 37.25 20.625H40.75C41.8546 20.625 42.75 21.5204 42.75 22.625V46.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.125 1.875H42.75V7.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.75 1.875L34.7029 9.92212C26.4313 18.1937 16.3475 24.4258 5.25 28.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 46.125H46.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2015_4334">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const MediaIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M7 20H13.5M9 20V16H8.5H6.75H4C3.73478 16 3.48043 15.8946 3.29289 15.7071C3.10536 15.5196 3 15.2652 3 15V5C3 4.73478 3.10536 4.48043 3.29289 4.29289C3.48043 4.10536 3.73478 4 4 4H20C20.2652 4 20.5196 4.10536 20.7071 4.29289C20.8946 4.48043 21 4.73478 21 5V15C21 15.2652 20.8946 15.5196 20.7071 15.7071C20.5196 15.8946 20.2652 16 20 16H13M9 12V8M12 12V11M15 12V10"
      stroke="#27AE60"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const RefreshIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20 10.9995C19.7554 9.23968 18.9391 7.60912 17.6766 6.35896C16.4142 5.10879 14.7758 4.30838 13.0137 4.08101C11.2516 3.85365 9.46362 4.21194 7.9252 5.10071C6.38678 5.98947 5.18325 7.3594 4.5 8.99946M4 4.99946V8.99946H8M4 12.9995C4.24456 14.7592 5.06093 16.3898 6.32336 17.64C7.58579 18.8901 9.22424 19.6905 10.9863 19.9179C12.7484 20.1453 14.5364 19.787 16.0748 18.8982C17.6132 18.0095 18.8168 16.6395 19.5 14.9995M20 18.9995V14.9995H16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const UploadIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 48 48" fill="none" {...props}>
    <g clipPath="url(#clip0_2015_4322)">
      <path
        d="M24 38.625V46.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 46.125H31.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 38.625H9.375C5.23284 38.625 1.875 35.2672 1.875 31.125V9.375C1.875 5.23284 5.23284 1.875 9.375 1.875H38.625C42.7672 1.875 46.125 5.23284 46.125 9.375V31.125C46.125 35.2672 42.7672 38.625 38.625 38.625H31.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16.875L24 9.375L31.5 16.875"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.25 27.375C35.25 29.446 33.571 31.125 31.5 31.125H16.5C14.429 31.125 12.75 29.446 12.75 27.375"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 23.625V9.375"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2015_4322">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const LoginIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M16.214 16.5V19.0714C16.214 19.4124 16.0785 19.7394 15.8374 19.9805C15.5963 20.2216 15.2693 20.3571 14.9283 20.3571H5.92829C5.5873 20.3571 5.26027 20.2216 5.01916 19.9805C4.77804 19.7394 4.64258 19.4124 4.64258 19.0714V4.92854C4.64258 4.58754 4.77804 4.26052 5.01916 4.0194C5.26027 3.77828 5.5873 3.64282 5.92829 3.64282H14.9283C15.2693 3.64282 15.5963 3.77828 15.8374 4.0194C16.0785 4.26052 16.214 4.58754 16.214 4.92854V7.49997"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
      <path
        d="M12.3574 12H21.3574"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
      <path
        d="M18.7861 9.42847L21.3576 11.9999L18.7861 14.5713"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const HamburgerIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 14 11" {...props}>
      <rect width="14" height="2" rx="1" fill="#currentColor" />
      <rect y="4.5" width="14" height="2" rx="1" fill="#currentColor" />
      <rect y="9" width="14" height="2" rx="1" fill="#currentColor" />
    </ChakraIcon>
  );
};

const MailIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 26 26" {...props}>
      <path
        d="M3.25 7.58464C3.25 7.01 3.47827 6.4589 3.8846 6.05257C4.29093 5.64624 4.84203 5.41797 5.41667 5.41797H20.5833C21.158 5.41797 21.7091 5.64624 22.1154 6.05257C22.5217 6.4589 22.75 7.01 22.75 7.58464V18.418C22.75 18.9926 22.5217 19.5437 22.1154 19.95C21.7091 20.3564 21.158 20.5846 20.5833 20.5846H5.41667C4.84203 20.5846 4.29093 20.3564 3.8846 19.95C3.47827 19.5437 3.25 18.9926 3.25 18.418V7.58464Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.25 7.58594L13 14.0859L22.75 7.58594"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ChakraIcon>
  );
};

const LogoIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 25" {...props}>
      <path
        d="M32 22.6176V10.8529L22.8571 24.5H30.1176C31.1572 24.5 32 23.6572 32 22.6176Z"
        fill="currentColor"
      />
      <path
        d="M9.38346 24.5L24.5042 0.932931C24.6773 0.663142 24.9758 0.5 25.2963 0.5H31.7594L16.1588 24.0782C15.9845 24.3416 15.6897 24.5 15.3739 24.5H9.38346Z"
        fill="currentColor"
      />
      <path
        d="M0 18.3824L11.2708 0.930569C11.4442 0.662135 11.7419 0.5 12.0614 0.5H18.2857L6.7752 17.9592C6.60105 18.2234 6.30583 18.3824 5.98943 18.3824H0Z"
        fill="currentColor"
      />
    </ChakraIcon>
  );
};

const XIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M18 6L6 18M6 6l12 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ChakraIcon>
  );
};

const PlusIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M12 4V20M4 12H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ChakraIcon>
  );
};

const GraduationCapIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 33 24" {...props}>
      <path
        d="M31.0002 8.99956V17.9996M30.1302 10.3826C30.3987 10.2641 30.6266 10.0695 30.7856 9.82276C30.9446 9.57607 31.0277 9.28814 31.0247 8.99466C31.0216 8.70119 30.9326 8.41504 30.7685 8.17168C30.6045 7.92833 30.3726 7.73844 30.1017 7.62556L17.2452 1.76956C16.8543 1.59128 16.4298 1.49902 16.0002 1.49902C15.5706 1.49902 15.146 1.59128 14.7552 1.76956L1.90019 7.61956C1.63314 7.73652 1.40596 7.92876 1.24644 8.17278C1.08691 8.4168 1.00195 8.70202 1.00195 8.99356C1.00195 9.2851 1.08691 9.57031 1.24644 9.81433C1.40596 10.0584 1.63314 10.2506 1.90019 10.3676L14.7552 16.2296C15.146 16.4078 15.5706 16.5001 16.0002 16.5001C16.4298 16.5001 16.8543 16.4078 17.2452 16.2296L30.1302 10.3826Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 12.75V18C7 19.1935 7.94821 20.3381 9.63604 21.182C11.3239 22.0259 13.6131 22.5 16 22.5C18.3869 22.5 20.6761 22.0259 22.364 21.182C24.0518 20.3381 25 19.1935 25 18V12.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </ChakraIcon>
  );
};

const UsersIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 32 30" {...props}>
      <path
        d="M22 28.5V25.5C22 23.9087 21.3679 22.3826 20.2426 21.2574C19.1174 20.1321 17.5913 19.5 16 19.5H7C5.4087 19.5 3.88258 20.1321 2.75736 21.2574C1.63214 22.3826 1 23.9087 1 25.5V28.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.5 13.5C14.8137 13.5 17.5 10.8137 17.5 7.5C17.5 4.18629 14.8137 1.5 11.5 1.5C8.18629 1.5 5.5 4.18629 5.5 7.5C5.5 10.8137 8.18629 13.5 11.5 13.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M31 28.5003V25.5003C30.999 24.1709 30.5565 22.8795 29.742 21.8288C28.9276 20.7781 27.7872 20.0277 26.5 19.6953M22 1.69531C23.2906 2.02576 24.4346 2.77636 25.2515 3.82878C26.0684 4.88119 26.5118 6.17556 26.5118 7.50781C26.5118 8.84007 26.0684 10.1344 25.2515 11.1868C24.4346 12.2393 23.2906 12.9899 22 13.3203"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </ChakraIcon>
  );
};

const CreditCardIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 36 36" {...props}>
      <path
        d="M30 7.5H6C4.34315 7.5 3 8.84315 3 10.5V25.5C3 27.1569 4.34315 28.5 6 28.5H30C31.6569 28.5 33 27.1569 33 25.5V10.5C33 8.84315 31.6569 7.5 30 7.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M3 15H33"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </ChakraIcon>
  );
};

const PuzzleIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 36 36" {...props}>
      <path
        d="M29.1576 11.7751C29.0841 12.2581 29.2461 12.7471 29.5911 13.0921L31.9431 15.4441C32.6481 16.1491 33.0021 17.0746 33.0021 18.0001C33.0021 18.9256 32.6496 19.8496 31.9431 20.5561L29.5266 22.9726C29.3642 23.1348 29.166 23.2568 28.948 23.3287C28.73 23.4006 28.4982 23.4204 28.2711 23.3866C27.5661 23.2816 27.0681 22.6666 26.8191 21.9991C26.6006 21.4092 26.2373 20.8838 25.7627 20.4711C25.288 20.0584 24.7172 19.7717 24.1028 19.6373C23.4883 19.5029 22.8499 19.5252 22.2463 19.702C21.6427 19.8789 21.0932 20.2047 20.6485 20.6494C20.2037 21.0942 19.8779 21.6437 19.701 22.2473C19.5242 22.8509 19.5019 23.4893 19.6363 24.1037C19.7707 24.7182 20.0574 25.289 20.4701 25.7637C20.8828 26.2383 21.4083 26.6016 21.9981 26.8201C22.6671 27.0691 23.2806 27.5656 23.3856 28.2721C23.4195 28.4991 23.3998 28.731 23.3279 28.949C23.256 29.1671 23.1339 29.3652 22.9716 29.5276L20.5566 31.9426C20.2212 32.2791 19.8226 32.5461 19.3837 32.7281C18.9448 32.9101 18.4742 33.0035 17.9991 33.0031C17.5243 33.0037 17.054 32.9104 16.6154 32.7287C16.1767 32.547 15.7783 32.2803 15.4431 31.9441L13.0911 29.5921C12.9211 29.4218 12.7135 29.2937 12.4851 29.2182C12.2566 29.1426 12.0136 29.1217 11.7756 29.1571C11.0361 29.2681 10.5156 29.9131 10.2456 30.6091C10.0193 31.19 9.65172 31.7053 9.17616 32.1084C8.7006 32.5115 8.13205 32.7896 7.52194 32.9177C6.91182 33.0458 6.2794 33.0198 5.68188 32.842C5.08435 32.6642 4.54058 32.3402 4.09976 31.8994C3.65894 31.4586 3.33497 30.9148 3.15717 30.3173C2.97936 29.7198 2.95333 29.0873 3.08143 28.4772C3.20952 27.8671 3.4877 27.2986 3.8908 26.823C4.29391 26.3474 4.80921 25.9799 5.3901 25.7536C6.0861 25.4836 6.7311 24.9631 6.8406 24.2236C6.87617 23.9857 6.85549 23.7428 6.7802 23.5143C6.70492 23.2858 6.57713 23.0782 6.4071 22.9081L4.0551 20.5561C3.71887 20.2208 3.45222 19.8224 3.27048 19.3838C3.08874 18.9451 2.99549 18.4749 2.9961 18.0001C2.9961 17.0746 3.3501 16.1491 4.0551 15.4441L6.3441 13.1551C6.7041 12.7951 7.2156 12.6256 7.7196 12.7006C8.4921 12.8161 9.0351 13.4926 9.3291 14.2156C9.56264 14.7882 9.93418 15.2942 10.4106 15.6884C10.8871 16.0827 11.4536 16.353 12.0598 16.4753C12.666 16.5976 13.2931 16.5681 13.8851 16.3894C14.4771 16.2107 15.0158 15.8883 15.453 15.451C15.8903 15.0137 16.2127 14.4751 16.3914 13.8831C16.5701 13.291 16.5996 12.664 16.4773 12.0578C16.355 11.4516 16.0847 10.885 15.6905 10.4086C15.2962 9.93216 14.7902 9.56062 14.2176 9.32707C13.4946 9.03307 12.8181 8.49007 12.7026 7.71757C12.6276 7.21357 12.7956 6.70357 13.1571 6.34207L15.4446 4.05457C15.7798 3.7188 16.178 3.45253 16.6164 3.27105C17.0547 3.08958 17.5246 2.99647 17.9991 2.99707C18.9246 2.99707 19.8501 3.35107 20.5551 4.05607L22.9071 6.40807C23.2521 6.75307 23.7411 6.91507 24.2226 6.84307C24.9621 6.73207 25.4826 6.08707 25.7526 5.39107C25.9789 4.81019 26.3465 4.29488 26.822 3.89178C27.2976 3.48868 27.8661 3.2105 28.4763 3.0824C29.0864 2.95431 29.7188 2.98034 30.3163 3.15815C30.9138 3.33595 31.4576 3.65992 31.8984 4.10074C32.3393 4.54156 32.6632 5.08533 32.841 5.68285C33.0188 6.28037 33.0449 6.9128 32.9168 7.52291C32.7887 8.13303 32.5105 8.70158 32.1074 9.17714C31.7043 9.6527 31.189 10.0203 30.6081 10.2466C29.9121 10.5166 29.2671 11.0356 29.1576 11.7751Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </ChakraIcon>
  );
};

const DocumentQuestionIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 36 36" {...props}>
      <path
        d="M22.5 3H9C8.20435 3 7.44129 3.31607 6.87868 3.87868C6.31607 4.44129 6 5.20435 6 6V30C6 30.7956 6.31607 31.5587 6.87868 32.1213C7.44129 32.6839 8.20435 33 9 33H27C27.7956 33 28.5587 32.6839 29.1213 32.1213C29.6839 31.5587 30 30.7956 30 30V10.5L22.5 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15 15.4503C15.3 14.8503 15.75 14.2503 16.35 13.9503C16.9712 13.5912 17.6964 13.4549 18.4056 13.564C19.1148 13.6731 19.7655 14.0211 20.25 14.5503C20.7 15.1503 21 15.7503 21 16.5003C21 18.4503 18 19.5003 18 19.5003M18 25.5003H18.015"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </ChakraIcon>
  );
};

const ExcelIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 48 48" {...props}>
      <path
        fill="#21a366"
        d="M29.544 2.954H13.787a1.969 1.969 0 0 0-1.969 1.969v8.371l17.726 10.34 8.863 3.74 8.863-3.74v-10.34Z"></path>
      <path fill="#107c41" d="M11.818 13.295h17.726v10.34H11.818Z"></path>
      <path
        fill="#33c481"
        d="M45.301 2.954H29.544v10.34H47.27V4.923a1.969 1.969 0 0 0-1.969-1.969Z"></path>
      <path
        fill="#185c37"
        d="M29.544 23.635H11.818v18.712a1.969 1.969 0 0 0 1.969 1.969h31.515a1.969 1.969 0 0 0 1.969-1.969v-8.372Z"></path>
      <path fill="#107c41" d="M29.544 23.635H47.27v10.34H29.544Z"></path>
      <path
        d="M24.618 10.34h-12.8v28.067h12.8a1.975 1.975 0 0 0 1.972-1.967V12.309a1.975 1.975 0 0 0-1.972-1.969Z"
        opacity=".1"></path>
      <path
        d="M23.144 11.818H11.818v28.067h11.326a1.975 1.975 0 0 0 1.969-1.967V13.787a1.975 1.975 0 0 0-1.969-1.969Z"
        opacity=".2"></path>
      <path
        d="M23.144 11.818H11.818V36.93h11.326a1.975 1.975 0 0 0 1.969-1.969V13.787a1.975 1.975 0 0 0-1.969-1.969Z"
        opacity=".2"></path>
      <path
        d="M21.667 11.818h-9.849V36.93h9.849a1.975 1.975 0 0 0 1.969-1.969V13.787a1.975 1.975 0 0 0-1.969-1.969Z"
        opacity=".2"></path>
      <path
        fill="#107c41"
        d="M1.969 11.818h19.7a1.969 1.969 0 0 1 1.969 1.969v19.7a1.969 1.969 0 0 1-1.969 1.969h-19.7A1.969 1.969 0 0 1 0 33.484V13.787a1.969 1.969 0 0 1 1.969-1.969Z"></path>
      <path
        fill="#fff"
        d="m5.219 31.021 4.78-7.407-4.378-7.365h3.523l2.39 4.708q.329.669.454 1h.031q.236-.535.495-1.04l2.554-4.668h3.234l-4.491 7.324 4.6 7.448h-3.438l-2.761-5.172a4.316 4.316 0 0 1-.329-.691h-.041a3.26 3.26 0 0 1-.319.669l-2.837 5.194Z"></path>
      <path fill="none" d="M0 0h47.271v47.271H0Z"></path>
    </ChakraIcon>
  );
};

const TrashIcon: React.FC<ChakraIconProps> = ({ ...props }) => {
  return (
    <ChakraIcon viewBox="0 0 20 20" {...props} fill="none">
      <path
        d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08203 4.13906L7.26536 3.0474C7.3987 2.25573 7.4987 1.66406 8.90703 1.66406H11.0904C12.4987 1.66406 12.607 2.28906 12.732 3.05573L12.9154 4.13906"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7096 7.61719L15.168 16.0089C15.0763 17.3172 15.0013 18.3339 12.6763 18.3339H7.3263C5.0013 18.3339 4.9263 17.3172 4.83464 16.0089L4.29297 7.61719"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.60938 13.75H11.3844"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91797 10.4141H12.0846"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ChakraIcon>
  );
};

const FacebookIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#clip0_2156_78)">
      <mask
        id="mask0_2156_78"
        maskUnits="userSpaceOnUse"
        x={-2}
        y={-2}
        width={28}
        height={28}>
        <path d="M-2 -1.99998H26V26H-2V-1.99998Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2156_78)">
        <path
          d="M22 12C22 6.47717 17.5228 2.00001 12 2.00001C6.47716 2.00001 2 6.47717 2 12C2 16.6898 5.2286 20.6249 9.58424 21.7055V15.0558H7.52216V12H9.58424V10.6832C9.58424 7.27957 11.1246 5.70197 14.4662 5.70197C15.0997 5.70197 16.1928 5.82617 16.64 5.95041V8.72057C16.404 8.69573 15.9941 8.68329 15.4848 8.68329C13.845 8.68329 13.2115 9.30441 13.2115 10.9193V12H16.4778L15.9167 15.0558H13.2115V21.9268C18.1629 21.3287 22 17.1127 22 12Z"
          fill="#0866FF"
        />
        <path
          d="M15.916 15.0558L16.4772 12H13.2108V10.9192C13.2108 9.30437 13.8444 8.68329 15.4841 8.68329C15.9934 8.68329 16.4033 8.69569 16.6394 8.72053V5.95041C16.1922 5.82617 15.099 5.70193 14.4655 5.70193C11.1239 5.70193 9.58356 7.27957 9.58356 10.6832V12H7.52148V15.0558H9.58356V21.7055C10.3573 21.8974 11.1663 22 11.9993 22C12.4095 22 12.8136 21.9747 13.2108 21.9268V15.0558H15.916Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2156_78">
        <rect width={20} height={20} fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const GoogleAdsIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_2156_666)">
      <path
        d="M8.84508 6.14183C9.03632 5.67002 9.29927 5.23566 9.68971 4.88368C11.2515 3.45328 13.8331 3.81275 14.8929 5.61011C15.6897 6.9731 16.5343 8.30614 17.355 9.65416C18.7256 11.8934 20.112 14.1326 21.4666 16.3793C22.606 18.259 21.371 20.633 19.108 20.955C17.7216 21.1498 16.4228 20.5506 15.7056 19.3824C14.5025 17.4127 13.2913 15.4431 12.0881 13.481C12.0642 13.4361 12.0323 13.3987 12.0005 13.3612C11.873 13.2639 11.8172 13.1216 11.7375 12.9942C11.2036 12.1105 10.6538 11.2343 10.12 10.3581C9.77736 9.78896 9.41879 9.22729 9.07616 8.65812C8.7654 8.14887 8.62198 7.59469 8.63791 7.01055C8.66182 6.71099 8.70166 6.41143 8.84508 6.14183Z"
        fill="#3C8BD9"
      />
      <path
        d="M8.84446 6.1416C8.77274 6.41121 8.709 6.68081 8.69306 6.96539C8.66916 7.59446 8.83649 8.17861 9.17115 8.7253C10.0476 10.1407 10.9241 11.5636 11.7927 12.9865C11.8723 13.1138 11.9361 13.2412 12.0158 13.361C11.5377 14.1398 11.0596 14.9112 10.5735 15.6901C9.90422 16.776 9.2349 17.8694 8.55761 18.9553C8.52573 18.9553 8.51776 18.9403 8.5098 18.9178C8.50183 18.8579 8.52573 18.8055 8.54167 18.7456C8.86836 17.6222 8.59745 16.6262 7.77673 15.7724C7.27474 15.2557 6.63729 14.9636 5.90422 14.8663C4.94804 14.739 4.10342 14.9711 3.34645 15.5328C3.21099 15.6301 3.12334 15.7724 2.96398 15.8473C2.93211 15.8473 2.91617 15.8323 2.9082 15.8099C3.29067 15.1883 3.66518 14.5667 4.04765 13.9451C5.62533 11.3689 7.20302 8.7927 8.78868 6.22398C8.80462 6.19402 8.82852 6.17156 8.84446 6.1416Z"
        fill="#FABC04"
      />
      <path
        d="M2.93984 15.8327C3.09123 15.7054 3.23466 15.5706 3.39402 15.4508C5.33028 14.0129 8.23864 15.0539 8.66095 17.3305C8.76454 17.8772 8.70876 18.4014 8.53346 18.9257C8.52549 18.9706 8.51753 19.008 8.50159 19.053C8.42988 19.1728 8.36613 19.3001 8.28645 19.4199C7.57729 20.5208 6.53346 21.0675 5.16294 20.9851C3.59322 20.8803 2.35816 19.7719 2.14302 18.3041C2.03944 17.5926 2.19083 16.9261 2.58127 16.312C2.66095 16.1772 2.75657 16.0574 2.84422 15.9226C2.88406 15.8926 2.86812 15.8327 2.93984 15.8327Z"
        fill="#34A852"
      />
      <path
        d="M2.94045 15.8327C2.90858 15.8626 2.90858 15.9151 2.8528 15.9226C2.84483 15.8701 2.87671 15.8402 2.90858 15.8027L2.94045 15.8327Z"
        fill="#FABC04"
      />
      <path
        d="M8.50148 19.0526C8.46961 19.0002 8.50148 18.9627 8.53336 18.9253C8.54132 18.9328 8.55726 18.9478 8.56523 18.9552L8.50148 19.0526Z"
        fill="#E1C025"
      />
    </g>
    <defs>
      <clipPath id="clip0_2156_666">
        <rect width="20" height="17" fill="white" transform="translate(2 4)" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const InstagramIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 264.5833 264.5833" fill="none" {...props}>
    <defs>
      {/* Linear gradients used by the radials */}
      <linearGradient id="a">
        <stop offset="0" stopColor="#fc0" />
        <stop offset=".1242" stopColor="#fc0" />
        <stop offset=".5672" stopColor="#fe4a05" />
        <stop offset=".6942" stopColor="#ff0f3f" />
        <stop offset="1" stopColor="#fe0657" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="b">
        <stop offset="0" stopColor="#fc0" />
        <stop offset="1" stopColor="#fc0" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="c">
        <stop offset="0" stopColor="#780cff" />
        <stop offset="1" stopColor="#820bff" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="d">
        <stop offset="0" stopColor="#ff005f" />
        <stop offset="1" stopColor="#fc01d8" />
      </linearGradient>

      {/* Radial gradients that reference the linears */}
      <radialGradient
        id="e"
        xlinkHref="#d"
        gradientUnits="userSpaceOnUse"
        cx="199.7884"
        cy="628.4379"
        r="52.3515"
        gradientTransform="matrix(-3.10797 .87652 -.6315 -2.23914 1345.6503 1374.1983)"
        fx="199.7884"
        fy="628.4379"
      />
      <radialGradient
        id="f"
        xlinkHref="#a"
        gradientUnits="userSpaceOnUse"
        cx="158.429"
        cy="578.088"
        r="52.3515"
        gradientTransform="matrix(0 -4.03418 4.28018 0 -2332.2273 942.2356)"
        fx="158.429"
        fy="578.088"
      />
      <radialGradient
        id="g"
        xlinkHref="#b"
        gradientUnits="userSpaceOnUse"
        cx="172.6149"
        cy="600.6924"
        r="65"
        gradientTransform="matrix(.67441 -1.16203 1.51283 .87801 -814.3657 -47.8354)"
        fx="172.6149"
        fy="600.6924"
      />
      <radialGradient
        id="h"
        xlinkHref="#c"
        gradientUnits="userSpaceOnUse"
        cx="144.012"
        cy="51.3367"
        r="67.081"
        gradientTransform="matrix(-2.3989 .67549 -.23008 -.81732 464.9957 -26.4035)"
        fx="144.012"
        fy="51.3367"
      />
    </defs>

    <g>
      {/* Four overlapping shells of the gradient border */}
      <path
        d="M204.1503 18.1429c-55.2305 0-71.3834.057-74.5232.3175-11.3342.9424-18.387 2.7275-26.0708 6.554-5.9214 2.9413-10.5915 6.3506-15.2005 11.1298-8.3938 8.7157-13.481 19.4383-15.3226 32.1842-.8953 6.1877-1.1558 7.4496-1.2087 39.0558-.0203 10.5354 0 24.4007 0 42.9984 0 55.2008.061 71.3418.3256 74.4764.9157 11.032 2.6453 17.9728 6.3081 25.565 7 14.5329 20.369 25.4428 36.119 29.5137 5.4535 1.4044 11.4767 2.1779 19.2092 2.5442 3.2762.1425 36.6684.2443 70.081.2443 33.4127 0 66.8253-.0407 70.02-.2035 8.9535-.4214 14.1526-1.1195 19.9011-2.6054 15.8517-4.0912 28.9767-14.8383 36.119-29.5748 3.5916-7.409 5.4128-14.6144 6.237-25.0704.179-2.2796.2543-38.6263.2543-74.924 0-36.304-.0814-72.5835-.2605-74.8632-.8343-10.6249-2.6555-17.7692-6.363-25.3207-3.0421-6.1816-6.42-10.798-11.324-15.518-8.752-8.3616-19.4555-13.4502-32.2101-15.2902-6.18-.8936-7.411-1.1582-39.033-1.2131z"
        fill="url(#e)"
        transform="translate(-71.8155 -18.1429)"
      />
      <path
        d="M204.1503 18.1429c-55.2305 0-71.3834.057-74.5232.3175-11.3342.9424-18.387 2.7275-26.0708 6.554-5.9214 2.9413-10.5915 6.3506-15.2005 11.1298-8.3938 8.7157-13.481 19.4383-15.3226 32.1842-.8953 6.1877-1.1558 7.4496-1.2087 39.0558-.0203 10.5354 0 24.4007 0 42.9984 0 55.2008.061 71.3418.3256 74.4764.9157 11.032 2.6453 17.9728 6.3081 25.565 7 14.5329 20.369 25.4428 36.119 29.5137 5.4535 1.4044 11.4767 2.1779 19.2092 2.5442 3.2762.1425 36.6684.2443 70.081.2443 33.4127 0 66.8253-.0407 70.02-.2035 8.9535-.4214 14.1526-1.1195 19.9011-2.6054 15.8517-4.0912 28.9767-14.8383 36.119-29.5748 3.5916-7.409 5.4128-14.6144 6.237-25.0704.179-2.2796.2543-38.6263.2543-74.924 0-36.304-.0814-72.5835-.2605-74.8632-.8343-10.6249-2.6555-17.7692-6.363-25.3207-3.0421-6.1816-6.42-10.798-11.324-15.518-8.752-8.3616-19.4555-13.4502-32.2101-15.2902-6.18-.8936-7.411-1.1582-39.033-1.2131z"
        fill="url(#f)"
        transform="translate(-71.8155 -18.1429)"
      />
      <path
        d="M204.1503 18.1429c-55.2305 0-71.3834.057-74.5232.3175-11.3342.9424-18.387 2.7275-26.0708 6.554-5.9214 2.9413-10.5915 6.3506-15.2005 11.1298-8.3938 8.7157-13.481 19.4383-15.3226 32.1842-.8953 6.1877-1.1558 7.4496-1.2087 39.0558-.0203 10.5354 0 24.4007 0 42.9984 0 55.2008.061 71.3418.3256 74.4764.9157 11.032 2.6453 17.9728 6.3081 25.565 7 14.5329 20.369 25.4428 36.119 29.5137 5.4535 1.4044 11.4767 2.1779 19.2092 2.5442 3.2762.1425 36.6684.2443 70.081.2443 33.4127 0 66.8253-.0407 70.02-.2035 8.9535-.4214 14.1526-1.1195 19.9011-2.6054 15.8517-4.0912 28.9767-14.8383 36.119-29.5748 3.5916-7.409 5.4128-14.6144 6.237-25.0704.179-2.2796.2543-38.6263.2543-74.924 0-36.304-.0814-72.5835-.2605-74.8632-.8343-10.6249-2.6555-17.7692-6.363-25.3207-3.0421-6.1816-6.42-10.798-11.324-15.518-8.752-8.3616-19.4555-13.4502-32.2101-15.2902-6.18-.8936-7.411-1.1582-39.033-1.2131z"
        fill="url(#g)"
        transform="translate(-71.8155 -18.1429)"
      />
      <path
        d="M204.1503 18.1429c-55.2305 0-71.3834.057-74.5232.3175-11.3342.9424-18.387 2.7275-26.0708 6.554-5.9214 2.9413-10.5915 6.3506-15.2005 11.1298-8.3938 8.7157-13.481 19.4383-15.3226 32.1842-.8953 6.1877-1.1558 7.4496-1.2087 39.0558-.0203 10.5354 0 24.4007 0 42.9984 0 55.2008.061 71.3418.3256 74.4764.9157 11.032 2.6453 17.9728 6.3081 25.565 7 14.5329 20.369 25.4428 36.119 29.5137 5.4535 1.4044 11.4767 2.1779 19.2092 2.5442 3.2762.1425 36.6684.2443 70.081.2443 33.4127 0 66.8253-.0407 70.02-.2035 8.9535-.4214 14.1526-1.1195 19.9011-2.6054 15.8517-4.0912 28.9767-14.8383 36.119-29.5748 3.5916-7.409 5.4128-14.6144 6.237-25.0704.179-2.2796.2543-38.6263.2543-74.924 0-36.304-.0814-72.5835-.2605-74.8632-.8343-10.6249-2.6555-17.7692-6.363-25.3207-3.0421-6.1816-6.42-10.798-11.324-15.518-8.752-8.3616-19.4555-13.4502-32.2101-15.2902-6.18-.8936-7.411-1.1582-39.033-1.2131z"
        fill="url(#h)"
        transform="translate(-71.8155 -18.1429)"
      />

      {/* central white camera shape */}
      <path
        d="M132.3452 33.973c-26.7167 0-30.0696.1167-40.5629.5939-10.4727.4792-17.6212 2.136-23.8762 4.567-6.4701 2.5107-11.9586 5.8693-17.4265 11.3352-5.472 5.464-8.8332 10.9483-11.354 17.4116-2.4389 6.2524-4.099 13.3976-4.5703 23.8585-.4693 10.4854-.5923 13.8379-.5923 40.5348 0 26.697.1189 30.0371.5943 40.5225.4817 10.465 2.1397 17.6082 4.5703 23.8585 2.5147 6.4654 5.8758 11.9497 11.3458 17.4136 5.466 5.468 10.9544 8.8349 17.4204 11.3456 6.259 2.4309 13.4097 4.0877 23.8803 4.567 10.4933.477 13.8441.5938 40.5588.5938 26.7188 0 30.0615-.1167 40.5547-.5939 10.4728-.4792 17.6295-2.136 23.8885-4.567 6.4681-2.5106 11.9484-5.8775 17.4143-11.3455 5.472-5.4639 8.8332-10.9482 11.354-17.4115 2.4183-6.2524 4.0784-13.3976 4.5703-23.8585.4713-10.4854.5943-13.8277.5943-40.5246 0-26.697-.123-30.0473-.5943-40.5328-.4919-10.465-2.152-17.6081-4.5703-23.8584-2.5208-6.4654-5.882-11.9498-11.354-17.4137-5.4721-5.468-10.9442-8.8266-17.4204-11.3353-6.2714-2.4309-13.424-4.0877-23.8967-4.5669-10.4933-.4772-13.8339-.5939-40.5588-.5939zm-8.825 17.7147c2.6193-.0041 5.5418 0 8.825 0 26.2659 0 29.379.0942 39.7513.5652 9.5915.4383 14.7971 2.0397 18.2648 3.3852 4.5908 1.7817 7.8638 3.9116 11.3048 7.3521 3.4431 3.4406 5.5745 6.7173 7.3617 11.3046 1.3465 3.461 2.9512 8.6628 3.3877 18.2472.4714 10.3625.5739 13.4754.5739 39.7095 0 26.234-.1025 29.347-.5739 39.7095-.4386 9.5843-2.0412 14.7861-3.3877 18.2471-1.783 4.5874-3.9186 7.8539-7.3617 11.2923-3.443 3.4406-6.712 5.5704-11.3048 7.3521-3.4636 1.3517-8.6733 2.949-18.2648 3.3873-10.3702.471-13.4854.5734-39.7513.5734-26.2679 0-29.381-.1024-39.7513-.5734-9.5914-.4423-14.797-2.0438-18.2668-3.3893-4.5908-1.7817-7.87-3.9116-11.313-7.3521-3.4431-3.4405-5.5745-6.709-7.3617-11.2985-1.3465-3.461-2.9512-8.6628-3.3877-18.2471-.4714-10.3626-.5657-13.4754-.5657-39.7259 0-26.2504.0943-29.347.5657-39.7095.4386-9.5844 2.0412-14.7861 3.3877-18.2512 1.783-4.5874 3.9186-7.8641 7.3617-11.3046 3.443-3.4406 6.7222-5.5704 11.313-7.3562 3.4677-1.3517 8.6754-2.949 18.2668-3.3894 9.075-.4096 12.5919-.5324 30.9264-.553zm61.3363 16.322c-6.5173 0-11.805 5.2776-11.805 11.792 0 6.5125 5.2877 11.7962 11.805 11.7962 6.5172 0 11.8049-5.2837 11.8049-11.7962 0-6.5124-5.2877-11.796-11.805-11.796zm-52.5113 13.7826c-27.8993 0-50.5191 22.6031-50.5191 50.4817 0 27.8786 22.6198 50.4714 50.5191 50.4714s50.511-22.5928 50.511-50.4714c0-27.8786-22.6137-50.4817-50.513-50.4817zm0 17.7147c18.109 0 32.7914 14.6694 32.7914 32.767 0 18.0956-14.6824 32.767-32.7914 32.767-18.111 0-32.7913-14.6714-32.7913-32.767 0-18.0976 14.6803-32.767 32.7913-32.767z"
        fill="#fff"
      />
    </g>
  </ChakraIcon>
);

const GoogleDriveIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 87.3 78" {...props}>
    <path
      fill="#0066da"
      d="m12.5161 61.79873 3.42585 5.91737c.71186 1.24576 1.73517 2.22458 2.93644 2.93644l12.23517-21.17796H6.64322c0 1.37923.35593 2.75847 1.0678 4.00423z"
      strokeWidth=".889831"
      transform="translate(1.06846 4.34545) scale(.93618066)"
    />
    <path
      fill="#00ac47"
      d="M45.48432 24.55932 33.24915 3.38136c-1.20127.71186-2.22457 1.69067-2.93644 2.93644L7.71101 45.47034a8.06186 8.06186 0 0 0-1.06779 4.00424h24.47034Z"
      strokeWidth=".889831"
      transform="translate(1.06846 4.34545) scale(.93618066)"
    />
    <path
      fill="#ea4335"
      d="M72.09025 70.65254c1.20128-.71186 2.22458-1.69068 2.93645-2.93644l1.42372-2.44703 6.8072-11.79026c.71187-1.24576 1.0678-2.625 1.0678-4.00423H59.85331l5.20728 10.23305z"
      strokeWidth=".889831"
      transform="translate(1.06846 4.34545) scale(.93618066)"
    />
    <path
      fill="#00832d"
      d="M45.48432 24.55932 57.7195 3.38136c-1.20127-.71187-2.5805-1.0678-4.00424-1.0678H37.2534c-1.42373 0-2.80297.40042-4.00424 1.0678z"
      strokeWidth=".889831"
      transform="translate(1.06846 4.34545) scale(.93618066)"
    />
    <path
      fill="#2684fc"
      d="M59.85509 49.47458H31.11356L18.87839 70.65254c1.20127.71187 2.5805 1.0678 4.00424 1.0678h45.20339c1.42373 0 2.80296-.40042 4.00423-1.0678z"
      strokeWidth=".889831"
      transform="translate(1.06846 4.34545) scale(.93618066)"
    />
    <path
      fill="#ffba00"
      d="M71.95678 25.89407 60.65593 6.3178c-.71186-1.24577-1.73517-2.22458-2.93644-2.93644L45.48432 24.55932 59.8551 49.47458h24.42584c0-1.37924-.35593-2.75848-1.0678-4.00424z"
      strokeWidth=".889831"
      transform="translate(1.06846 4.34545) scale(.93618066)"
    />
  </ChakraIcon>
);

const LinkedInIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M2.70703 3.98843C2.70703 3.24868 3.32192 2.64864 4.08046 2.64864H19.9191C20.6776 2.64864 21.2925 3.24868 21.2925 3.98843V20.0123C21.2925 20.7523 20.6776 21.3521 19.9191 21.3521H4.08046C3.32192 21.3521 2.70703 20.7523 2.70703 20.0123V3.98843Z"
      fill="#006699"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.34226 18.3052V9.85954H5.53508V18.3052H8.34226ZM6.93866 8.70643C7.91758 8.70643 8.52687 8.0579 8.52687 7.24742C8.50863 6.4187 7.91758 5.78817 6.95723 5.78817C5.99698 5.78817 5.36914 6.4187 5.36914 7.24742C5.36914 8.0579 5.97831 8.70643 6.92036 8.70643H6.93866Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.89453 18.3052H12.7017V13.5888C12.7017 13.3364 12.7199 13.0842 12.794 12.9038C12.997 12.3994 13.4589 11.8771 14.2344 11.8771C15.2501 11.8771 15.6565 12.6516 15.6565 13.787V18.3052H18.4634V13.4626C18.4634 10.8684 17.0785 9.66136 15.2316 9.66136C13.7172 9.66136 13.0524 10.5078 12.683 11.0844H12.7018V9.85954H9.89461C9.93145 10.652 9.89453 18.3052 9.89453 18.3052Z"
      fill="white"
    />
  </ChakraIcon>
);

const YouTubeIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
      fill="#FF0000"
    />
  </ChakraIcon>
);

const AmplitudeIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 64 64" {...props}>
    <g>
      <path
        d="M28.2,14.4C28,14.2,27.8,14,27.6,14c-0.2,0-0.3,0.1-0.5,0.2c-1.7,1.3-4,7-5.9,14.5l1.7,0   c3.3,0,6.8,0.1,10.2,0.1c-0.9-3.4-1.7-6.4-2.5-8.7C29.4,16.6,28.7,15.1,28.2,14.4z"
        fill="#00A7CF"
      />
      <path
        d="M32,0C14.3,0,0,14.3,0,32s14.3,32,32,32s32-14.3,32-32S49.7,0,32,0z M55,32.6L55,32.6c0,0-0.1,0.1-0.1,0.1l0,0   l-0.1,0l-0.1,0l0,0c-0.2,0.1-0.5,0.2-0.8,0.2H38.8c0.1,0.5,0.3,1.1,0.4,1.7c0.8,3.6,3,13.1,5.4,13.1h0.1h0h0c1.8,0,2.8-2.6,4.8-8.4   l0-0.1c0.3-0.9,0.7-2,1.1-3.1l0.1-0.3l0,0c0.1-0.4,0.5-0.6,0.9-0.5c0.4,0.1,0.6,0.5,0.5,0.9l0,0L52,36.6c-0.2,0.7-0.4,1.6-0.7,2.7   c-1.2,5.1-3.1,12.7-7.8,12.7h0c-3.1,0-4.9-4.9-5.7-7c-1.5-3.9-2.6-8.1-3.6-12.1h-14l-2.9,9.3l0,0c-0.4,0.7-1.3,0.9-2,0.5   c-0.4-0.3-0.7-0.7-0.7-1.2v-0.1l0.2-1c0.4-2.4,0.9-4.9,1.4-7.4h-5.9l0,0c-1.1-0.2-1.9-1.1-1.9-2.2c0-1.1,0.8-2,1.8-2.2   c0.2,0,0.5,0,0.7,0h0.3c1.9,0,3.8,0.1,6,0.1c3.1-12.5,6.6-18.8,10.6-18.9c4.2,0,7.4,9.7,9.9,19.1l0,0c5.2,0.1,10.7,0.3,16,0.6   l0.2,0c0.1,0,0.2,0,0.3,0h0h0h0c0.9,0.2,1.5,1.1,1.3,2C55.5,32,55.3,32.3,55,32.6z"
        fill="#00A7CF"
      />
    </g>
  </ChakraIcon>
);

const ShopifyIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M14.49 20.937l5.381-1.164S17.93 6.633 17.914 6.546c-.013-.086-.085-.143-.157-.143-.073 0-1.439-.101-1.439-.101s-.951-.95-1.073-1.052c-.034-.028-.056-.043-.09-.055l-.682 15.742h.017zM11.784 11.483s-.604-.316-1.323-.316c-1.08 0-1.122.676-1.122.851 0 .919 2.417 1.279 2.417 3.453 0 1.712-1.074 2.804-2.54 2.804-1.756 0-2.641-1.092-2.641-1.092l.482-1.556s.929.795 1.7.795c.504 0 .716-.406.716-.695 0-1.208-1.98-1.264-1.98-3.252-.025-1.668 1.172-3.294 3.6-3.294.938 0 1.399.269 1.399.269l-.705 2.025-.003.008zM11.381 3.667c.101 0 .202.028.302.101-.734.347-1.54 1.222-1.871 2.978-.489.159-.964.302-1.409.431.393-1.331 1.328-3.502 2.983-3.502l-.005-.008zm.921 2.199v.101c-.562.173-1.181.361-1.786.549.348-1.326.994-1.973 1.556-2.216.144.374.23.877.23 1.566zm.402-1.667c.518.055.851.647 1.066 1.31-.26.085-.548.172-.864.273v-.188c0-.561-.072-1.023-.202-1.395zm2.232.962c-.015 0-.045.015-.058.015-.014 0-.216.056-.561.165-.346-.999-.957-1.916-2.033-1.916h-.1c-.303-.389-.684-.431-1.007-.431-2.443 0-3.612 3.055-3.979 4.607-.95.294-1.626.503-1.712.532-.531.166-.545.18-.617.68-.058.374-1.442 11.1-1.442 11.1l10.759 2.015.684-15.775c-.031-.006-.046-.006-.078-.006"
      fill="#95BF47"
    />
  </ChakraIcon>
);

const GoogleAnalyticsIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M15.082 5.92695V17.8919C15.082 19.2317 16.0055 19.9767 16.9855 19.9767C17.892 19.9767 18.8891 19.3422 18.8891 17.8919V6.01759C18.8891 4.79107 17.9826 4.02344 16.9855 4.02344C15.9885 4.02344 15.082 4.87039 15.082 5.92695Z"
      fill="#F8AB00"
    />
    <path
      d="M10.0967 12.0002V17.892C10.0967 19.2319 11.0201 19.9768 12.0002 19.9768C12.9066 19.9768 13.9037 19.3423 13.9037 17.892V12.0908C13.9037 10.8643 12.9973 10.0967 12.0002 10.0967C11.0031 10.0967 10.0967 10.9436 10.0967 12.0002Z"
      fill="#E37300"
    />
    <path
      d="M8.91836 18.0734C8.91836 19.1243 8.06574 19.977 7.01484 19.977C5.96394 19.977 5.11133 19.1243 5.11133 18.0734C5.11133 17.0225 5.96394 16.1699 7.01484 16.1699C8.06574 16.1699 8.91836 17.0225 8.91836 18.0734Z"
      fill="#E37300"
    />
  </ChakraIcon>
);

const HubspotIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 250 250" fill="none" {...props}>
    <path
      fill="#FF7A59"
      d="M178.194 90.764V65.867a19.172 19.172 0 0 0 11.054-17.281v-.571c0-10.59-8.584-19.173-19.172-19.173h-.572c-10.588 0-19.172 8.584-19.172 19.173v.57a19.166 19.166 0 0 0 11.054 17.282v24.897a54.29 54.29 0 0 0-25.815 11.366L67.29 48.945a21.41 21.41 0 0 0 .77-5.379 21.602 21.602 0 1 0-21.63 21.56 21.368 21.368 0 0 0 10.638-2.895l67.238 52.321c-12.362 18.674-12.031 43.011.833 61.343l-20.451 20.456a17.56 17.56 0 0 0-5.11-.832c-9.794.008-17.728 7.951-17.726 17.745.003 9.793 7.942 17.731 17.735 17.734 9.794.002 17.736-7.932 17.745-17.726a17.495 17.495 0 0 0-.834-5.11l20.231-20.238c18.076 13.915 42.903 15.114 62.237 3.005 19.333-12.11 29.09-34.972 24.457-57.308-4.632-22.338-22.675-39.434-45.229-42.858Zm-8.386 81.884a27.998 27.998 0 0 1-20.276-7.923 27.995 27.995 0 0 1-6.262-30.94 27.985 27.985 0 0 1 26.538-17.094c15.062.527 27.001 12.886 27.01 27.958.006 15.07-11.921 27.442-26.982 27.984"
    />
  </ChakraIcon>
);

const StripeIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 250 250" fill="none" {...props}>
    <defs>
      <clipPath id="a">
        <path d="M29 29h193v193H29z" fill="#fff" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)">
      <path
        fill="#6772E5"
        d="M178.68 29H72.32C48.395 29 29 48.395 29 72.32v106.36C29 202.605 48.395 222 72.32 222h106.36c23.925 0 43.32-19.395 43.32-43.32V72.32C222 48.395 202.605 29 178.68 29Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.912 103.874c0-4.613 3.811-6.685 9.961-6.685a65.777 65.777 0 0 1 29.214 7.554V77.4a77.544 77.544 0 0 0-29.147-5.348c-23.799 0-39.71 12.435-39.71 33.426 0 32.49 44.657 27.209 44.657 41.247 0 5.415-4.746 7.153-11.231 7.153a73.927 73.927 0 0 1-32.49-9.559v28.01a81.484 81.484 0 0 0 32.089 6.686c24.401 0 41.247-12.034 41.247-33.426.201-34.83-44.59-28.546-44.59-41.715Z"
      />
    </g>
  </ChakraIcon>
);

const SalesforceIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 250 250" fill="none" {...props}>
    <defs>
      <mask
        id="a"
        maskUnits="userSpaceOnUse"
        x={15}
        y={47}
        width={219}
        height={156}>
        <path fill="#fff" d="M15 47.44h218.668V203H15" />
      </mask>
    </defs>
    <g mask="url(#a)">
      <path
        fill="#129CD8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.995 64.405c7.051-7.467 16.869-12.1 27.728-12.1 14.436 0 27.028 8.18 33.735 20.324a46.009 46.009 0 0 1 19.067-4.119c26.035 0 47.143 21.64 47.143 48.333 0 26.696-21.108 48.336-47.143 48.336a46.35 46.35 0 0 1-9.288-.941c-5.903 10.703-17.158 17.939-30.077 17.939a33.821 33.821 0 0 1-15.076-3.528c-5.984 14.313-19.935 24.35-36.19 24.35-16.93 0-31.36-10.886-36.898-26.156-2.42.519-4.93.793-7.5.793-20.157 0-36.496-16.779-36.496-37.478 0-13.875 7.337-25.987 18.248-32.468a43.519 43.519 0 0 1-3.493-17.145c0-23.805 19.015-43.105 42.47-43.105 13.77 0 26.008 6.653 33.77 16.965Z"
      />
    </g>
    <path
      fill="#FEFEFE"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.67 128.109c-.138.365.048.441.093.503.412.304.826.522 1.247.768 2.23 1.201 4.339 1.551 6.54 1.551 4.487 0 7.273-2.424 7.273-6.327v-.075c0-3.61-3.146-4.923-6.093-5.87l-.386-.124c-2.224-.735-4.142-1.369-4.142-2.858v-.075c0-1.274 1.121-2.212 2.86-2.212 1.931 0 4.223.654 5.698 1.484 0 0 .437.284.594-.144.087-.232.833-2.274.913-2.496.084-.238-.064-.418-.218-.512-1.688-1.042-4.018-1.755-6.428-1.755l-.447.004c-4.107 0-6.974 2.521-6.974 6.134v.075c0 3.805 3.163 5.043 6.126 5.902l.476.15c2.16.673 4.02 1.255 4.02 2.797v.078c0 1.411-1.212 2.463-3.16 2.463-.758 0-3.171-.013-5.778-1.689-.315-.19-.495-.323-.739-.474-.128-.081-.45-.221-.591.206l-.884 2.496Zm65.666 0c-.139.365.048.441.093.503.411.304.826.522 1.247.768 2.23 1.201 4.338 1.551 6.54 1.551 4.486 0 7.272-2.424 7.272-6.327v-.075c0-3.61-3.146-4.923-6.093-5.87l-.385-.124c-2.224-.735-4.143-1.369-4.143-2.858v-.075c0-1.274 1.122-2.212 2.86-2.212 1.932 0 4.223.654 5.698 1.484 0 0 .437.284.595-.144.087-.232.832-2.274.913-2.496.083-.238-.064-.418-.219-.512-1.687-1.042-4.014-1.755-6.427-1.755l-.447.004c-4.107 0-6.974 2.521-6.974 6.134v.075c0 3.805 3.166 5.043 6.126 5.902l.475.15c2.16.673 4.024 1.255 4.024 2.797v.078c0 1.411-1.212 2.463-3.163 2.463-.758 0-3.168-.013-5.778-1.689-.315-.19-.501-.317-.739-.474-.081-.052-.46-.202-.588.206l-.887 2.496Zm44.828-7.648c0 2.205-.405 3.946-1.202 5.174-.79 1.215-1.983 1.81-3.644 1.81-1.665 0-2.851-.595-3.629-1.81-.787-1.228-1.185-2.969-1.185-5.174 0-2.201.398-3.939 1.182-5.154.781-1.202 1.967-1.787 3.632-1.787 1.661 0 2.854.585 3.644 1.787.797 1.215 1.202 2.953 1.202 5.154Zm3.744-4.089c-.366-1.264-.942-2.378-1.703-3.305a8.212 8.212 0 0 0-2.877-2.222c-1.144-.542-2.494-.82-4.01-.82-1.521 0-2.874.278-4.018.82a8.206 8.206 0 0 0-2.873 2.225c-.765.928-1.337 2.042-1.703 3.302-.367 1.258-.553 2.633-.553 4.089 0 1.457.186 2.836.553 4.09.366 1.261.938 2.375 1.703 3.306a8.045 8.045 0 0 0 2.877 2.204c1.144.529 2.493.798 4.014.798 1.516 0 2.863-.269 4.01-.798a8.08 8.08 0 0 0 2.877-2.204c.761-.928 1.337-2.042 1.703-3.306.366-1.258.553-2.633.553-4.09 0-1.456-.187-2.831-.553-4.089Zm30.747 10.481c-.122-.369-.479-.228-.479-.228-.543.212-1.122.405-1.742.503-.623.101-1.311.15-2.05.15-1.81 0-3.253-.549-4.284-1.63-1.032-1.084-1.614-2.835-1.607-5.203.006-2.153.517-3.773 1.436-5.011.913-1.228 2.305-1.858 4.156-1.858 1.542 0 2.722.183 3.956.575 0 0 .296.13.434-.262.331-.928.572-1.584.922-2.6.1-.29-.144-.411-.235-.447-.485-.193-1.629-.51-2.497-.644a18.763 18.763 0 0 0-2.809-.189c-1.571 0-2.972.274-4.171.816a8.645 8.645 0 0 0-3.018 2.218c-.803.931-1.414 2.045-1.819 3.306-.408 1.257-.61 2.636-.61 4.099 0 3.155.835 5.707 2.49 7.572 1.659 1.878 4.146 2.828 7.392 2.828 1.919 0 3.886-.395 5.303-.96 0 0 .27-.134.151-.454l-.919-2.581Zm6.551-8.505c.18-1.225.511-2.244 1.025-3.038.775-1.205 1.958-1.872 3.622-1.872 1.665 0 2.761.667 3.551 1.872.524.797.752 1.855.842 3.041l-9.04-.003Zm12.604-2.692c-.317-1.221-1.105-2.453-1.619-3.015-.816-.895-1.617-1.519-2.407-1.865a9.105 9.105 0 0 0-3.632-.748c-1.581 0-3.018.271-4.184.827a8.342 8.342 0 0 0-2.919 2.263c-.768.944-1.346 2.068-1.715 3.345-.37 1.268-.557 2.649-.557 4.109 0 1.486.193 2.871.576 4.112.386 1.258 1.002 2.359 1.835 3.277.835.921 1.906 1.639 3.188 2.145 1.276.5 2.825.762 4.602.755 3.661-.01 5.589-.839 6.383-1.287.141-.082.273-.219.109-.617l-.833-2.358c-.125-.35-.475-.223-.475-.223-.91.343-2.195.957-5.203.951-1.964-.003-3.423-.591-4.336-1.516-.935-.94-1.398-2.325-1.475-4.282l12.672.01s.335-.004.37-.336c.013-.138.433-2.646-.38-5.547Z"
    />
  </ChakraIcon>
);

const MinimizeIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_1453_95355)">
      <path
        d="M18 10H14V6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 4L14 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 14H10V18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14L4 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </ChakraIcon>
);

const DisplayIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 56 56" fill="none" {...props}>
    <g clipPath="url(#clip0_6002_127)">
      <path
        d="M7 11.6663C7 11.0475 7.24583 10.454 7.68342 10.0164C8.121 9.57884 8.71449 9.33301 9.33333 9.33301H46.6667C47.2855 9.33301 47.879 9.57884 48.3166 10.0164C48.7542 10.454 49 11.0475 49 11.6663V34.9997C49 35.6185 48.7542 36.212 48.3166 36.6496C47.879 37.0872 47.2855 37.333 46.6667 37.333H9.33333C8.71449 37.333 8.121 37.0872 7.68342 36.6496C7.24583 36.212 7 35.6185 7 34.9997V11.6663Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.333 46.667H39.6663"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 37.333V46.6663"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 37.333V46.6663"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 28.0003V18.667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 28.0003V25.667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 27.9997V23.333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 28.0003V25.667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </ChakraIcon>
);

const CouldAiIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 56 56" fill="none" {...props}>
    <path
      d="M11.6875 29.9375H9.9375C5.10498 29.9375 1.1875 26.02 1.1875 21.1875C1.1875 16.6531 4.63664 12.9247 9.0543 12.4818C10.0506 7.4675 14.4743 3.6875 19.7812 3.6875C21.5747 3.6875 23.2671 4.11909 24.7608 4.88417C26.9257 2.78953 29.8746 1.5 33.125 1.5C39.423 1.5 44.5899 6.33941 45.112 12.5024C49.4493 13.0212 52.8125 16.7105 52.8125 21.1875C52.8125 26.02 48.895 29.9375 44.0625 29.9375H42.3125M27 38.6875V27.75C27 25.3338 25.0412 23.375 22.625 23.375C20.2088 23.375 18.25 25.3338 18.25 27.75V38.6875M18.25 32.125H27M35.75 38.6875V21.1875"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </ChakraIcon>
);

const ScenarioIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 56 56" fill="none" {...props}>
    <g clipPath="url(#clip0_6002_642)">
      <path
        d="M7 9.33301H49"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 9.33301V32.6663C9.33301 33.904 9.82467 35.091 10.6998 35.9662C11.575 36.8413 12.762 37.333 13.9997 37.333H41.9997C43.2374 37.333 44.4243 36.8413 45.2995 35.9662C46.1747 35.091 46.6663 33.904 46.6663 32.6663V9.33301"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 37.333V46.6663"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 46.667H35"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.667 28.0003L25.667 21.0003L30.3337 25.667L37.3337 18.667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6002_642">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const CalendarIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 56 56" fill="none" {...props}>
    <g clipPath="url(#clip0_6002_309)">
      <path
        d="M31.4997 49.0003H13.9997C12.762 49.0003 11.575 48.5087 10.6998 47.6335C9.82467 46.7583 9.33301 45.5713 9.33301 44.3337V16.3337C9.33301 15.096 9.82467 13.909 10.6998 13.0338C11.575 12.1587 12.762 11.667 13.9997 11.667H41.9997C43.2374 11.667 44.4243 12.1587 45.2995 13.0338C46.1747 13.909 46.6663 15.096 46.6663 16.3337V28.0003"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.333 7V16.3333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.667 7V16.3333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 25.667H46.6663"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.3337 37.333L39.667 44.333H49.0003L44.3337 51.333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6002_309">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const ReportIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 56 56" fill="none" {...props}>
    <g clipPath="url(#clip0_6002_984)">
      <path
        d="M32.667 7V16.3333C32.667 16.9522 32.9128 17.5457 33.3504 17.9832C33.788 18.4208 34.3815 18.6667 35.0003 18.6667H44.3337"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.667 49H16.3337C15.096 49 13.909 48.5083 13.0338 47.6332C12.1587 46.758 11.667 45.571 11.667 44.3333V11.6667C11.667 10.429 12.1587 9.242 13.0338 8.36683C13.909 7.49167 15.096 7 16.3337 7H32.667L44.3337 18.6667V44.3333C44.3337 45.571 43.842 46.758 42.9668 47.6332C42.0917 48.5083 40.9047 49 39.667 49Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 39.6667V28"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 39.6663V37.333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 39.667V32.667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6002_984">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const BrainIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_6028_17290)">
      <path
        d="M15.5 13C14.5717 13 13.6815 13.3687 13.0251 14.0251C12.3687 14.6815 12 15.5717 12 16.5V17.5C12 18.4283 12.3687 19.3185 13.0251 19.9749C13.6815 20.6313 14.5717 21 15.5 21C16.4283 21 17.3185 20.6313 17.9749 19.9749C18.6313 19.3185 19 18.4283 19 17.5V15.7"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 13C9.42826 13 10.3185 13.3687 10.9749 14.0251C11.6313 14.6815 12 15.5717 12 16.5V17.5C12 18.4283 11.6313 19.3185 10.9749 19.9749C10.3185 20.6313 9.42826 21 8.5 21C7.57174 21 6.6815 20.6313 6.02513 19.9749C5.36875 19.3185 5 18.4283 5 17.5V15.7"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 16C18.4283 16 19.3185 15.6313 19.9749 14.9749C20.6313 14.3185 21 13.4283 21 12.5C21 11.5717 20.6313 10.6815 19.9749 10.0251C19.3185 9.36875 18.4283 9 17.5 9H17"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 9.3V6.5C19 5.57174 18.6313 4.6815 17.9749 4.02513C17.3185 3.36875 16.4283 3 15.5 3C14.5717 3 13.6815 3.36875 13.0251 4.02513C12.3687 4.6815 12 5.57174 12 6.5"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 16C5.57174 16 4.6815 15.6313 4.02513 14.9749C3.36875 14.3185 3 13.4283 3 12.5C3 11.5717 3.36875 10.6815 4.02513 10.0251C4.6815 9.36875 5.57174 9 6.5 9H7"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9.3V6.5C5 5.57174 5.36875 4.6815 6.02513 4.02513C6.6815 3.36875 7.57174 3 8.5 3C9.42826 3 10.3185 3.36875 10.9749 4.02513C11.6313 4.6815 12 5.57174 12 6.5V16.5"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6028_17290">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const ScaleIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M7 20H17"
      stroke="#2C3E50"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L12 5L18 6"
      stroke="#2C3E50"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V20"
      stroke="#2C3E50"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L6 6L3 12C3 12.7956 3.31607 13.5587 3.87868 14.1213C4.44129 14.6839 5.20435 15 6 15C6.79565 15 7.55871 14.6839 8.12132 14.1213C8.68393 13.5587 9 12.7956 9 12Z"
      stroke="#2C3E50"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12L18 6L15 12C15 12.7956 15.3161 13.5587 15.8787 14.1213C16.4413 14.6839 17.2044 15 18 15C18.7956 15 19.5587 14.6839 20.1213 14.1213C20.6839 13.5587 21 12.7956 21 12Z"
      stroke="#2C3E50"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const LinkIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_6028_17300)">
      <path
        d="M9 15L15 9"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 6.00031L11.463 5.46431C12.4008 4.52663 13.6727 3.99991 14.9989 4C16.325 4.00009 17.5968 4.527 18.5345 5.46481C19.4722 6.40261 19.9989 7.6745 19.9988 9.00066C19.9987 10.3268 19.4718 11.5986 18.534 12.5363L18 13.0003"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0001 18L12.6031 18.534C11.6544 19.4722 10.3739 19.9984 9.03964 19.9984C7.70535 19.9984 6.42489 19.4722 5.47614 18.534C5.0085 18.0716 4.63724 17.521 4.38385 16.9141C4.13047 16.3073 4 15.6561 4 14.9985C4 14.3408 4.13047 13.6897 4.38385 13.0829C4.63724 12.476 5.0085 11.9254 5.47614 11.463L6.00014 11"
        stroke="#2C3E50"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6028_17300">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const MailUpIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_6028_17303)">
      <path
        d="M12 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V12.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 22V16"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 19L19 16L16 19"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7L12 13L21 7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6028_17303">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const MinusIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g opacity="0.8" clipPath="url(#clip0_4461_5319)">
        <path
          d="M5 12H19"
          stroke="#2C3E50"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4461_5319">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ChakraIcon>
);

const SortIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 12 12" fill="none" {...props}>
    <path
      d="M8.5 1.5V10.5M8.5 1.5L10 3M8.5 1.5L7 3M5 9L3.5 10.5M3.5 10.5L2 9M3.5 10.5V1.5"
      stroke="#92A5B8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const SortUpIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 12 12" fill="none" {...props}>
    <path
      d="M8.5 1.5V10.5M8.5 1.5L10 3M8.5 1.5L7 3"
      stroke="#92A5B8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const SortDownIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 12 12" fill="none" {...props}>
    <path
      d="M5 9L3.5 10.5M3.5 10.5L2 9M3.5 10.5V1.5"
      stroke="#92A5B8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const MMMUpdated: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 20 21" fill="none" {...props}>
    <path
      d="M19.2227 9.63815V2.87407C19.2227 1.38199 18.5861 0.785156 17.0045 0.785156H12.9858C11.4042 0.785156 10.7676 1.38199 10.7676 2.87407V9.63815C10.7676 11.1302 11.4042 11.7271 12.9858 11.7271H17.0045C18.5861 11.7271 19.2227 11.1302 19.2227 9.63815Z"
      fill="currentColor"
    />
    <path
      d="M8.77738 11.8272V18.5913C8.77738 20.0834 8.14076 20.6802 6.55915 20.6802H2.54049C0.958886 20.6802 0.322266 20.0834 0.322266 18.5913V11.8272C0.322266 10.3351 0.958886 9.73828 2.54049 9.73828H6.55915C8.14076 9.73828 8.77738 10.3351 8.77738 11.8272Z"
      fill="currentColor"
    />
    <path
      d="M19.2227 18.5909V15.8057C19.2227 14.3136 18.5861 13.7168 17.0045 13.7168H12.9858C11.4042 13.7168 10.7676 14.3136 10.7676 15.8057V18.5909C10.7676 20.083 11.4042 20.6798 12.9858 20.6798H17.0045C18.5861 20.6798 19.2227 20.083 19.2227 18.5909Z"
      fill="currentColor"
    />
    <path
      d="M8.77738 5.65928V2.87407C8.77738 1.38199 8.14076 0.785156 6.55915 0.785156H2.54049C0.958886 0.785156 0.322266 1.38199 0.322266 2.87407V5.65928C0.322266 7.15136 0.958886 7.74819 2.54049 7.74819H6.55915C8.14076 7.74819 8.77738 7.15136 8.77738 5.65928Z"
      fill="currentColor"
    />
  </ChakraIcon>
);

const MarketingOptimization: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 25" fill="none" {...props}>
    <path
      d="M1.94531 17.3398H11.5195"
      stroke="currentColor"
      strokeWidth="1.55673"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.07076 13.9316H9.39408C11.0983 13.9316 11.5195 14.3529 11.5195 16.038V19.973C11.5195 21.658 11.0983 22.0793 9.39408 22.0793H4.07076C2.36655 22.0793 1.94531 21.658 1.94531 19.973V16.038C1.94531 14.3529 2.36655 13.9316 4.07076 13.9316Z"
      stroke="currentColor"
      strokeWidth="1.55673"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0965 15.3691C21.0965 19.0744 18.0998 22.0711 14.3945 22.0711L15.3998 20.3956"
      stroke="currentColor"
      strokeWidth="1.55673"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.94531 9.62383C1.94531 5.91861 4.94204 2.92188 8.64726 2.92188L7.64198 4.59736"
      stroke="currentColor"
      strokeWidth="1.55673"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7459 11.5387C20.1254 11.5387 22.0543 9.60974 22.0543 7.23027C22.0543 4.85081 20.1254 2.92188 17.7459 2.92188C15.3664 2.92188 13.4375 4.85081 13.4375 7.23027C13.4375 9.60974 15.3664 11.5387 17.7459 11.5387Z"
      stroke="currentColor"
      strokeWidth="1.55673"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const ClipboardIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 25" fill="none" {...props}>
    <path
      d="M16.0252 4.44984C16.9609 4.44984 17.4287 4.44984 17.8126 4.55269C18.8543 4.8318 19.6679 5.64543 19.947 6.68709C20.0499 7.07094 20.0499 7.5388 20.0499 8.47451V17.7312C20.0499 19.4218 20.0499 20.267 19.7209 20.9127C19.4315 21.4807 18.9697 21.9425 18.4017 22.2319C17.756 22.5609 16.9108 22.5609 15.2202 22.5609H8.78078C7.09026 22.5609 6.245 22.5609 5.5993 22.2319C5.03134 21.9425 4.56956 21.4807 4.28017 20.9127C3.95117 20.267 3.95117 19.4218 3.95117 17.7312V8.47451C3.95117 7.5388 3.95117 7.07094 4.05402 6.68709C4.33314 5.64543 5.14677 4.8318 6.18843 4.55269C6.57228 4.44984 7.04014 4.44984 7.97584 4.44984M9.58571 6.46217H14.4153C14.9788 6.46217 15.2606 6.46217 15.4758 6.35251C15.6651 6.25604 15.8191 6.10212 15.9155 5.91279C16.0252 5.69756 16.0252 5.41581 16.0252 4.8523V4.04737C16.0252 3.48386 16.0252 3.20211 15.9155 2.98688C15.8191 2.79755 15.6651 2.64363 15.4758 2.54717C15.2606 2.4375 14.9788 2.4375 14.4153 2.4375H9.58571C9.0222 2.4375 8.74045 2.4375 8.52522 2.54717C8.3359 2.64363 8.18197 2.79755 8.08551 2.98688C7.97584 3.20211 7.97584 3.48386 7.97584 4.04737V4.8523C7.97584 5.41581 7.97584 5.69756 8.08551 5.91279C8.18197 6.10212 8.3359 6.25604 8.52522 6.35251C8.74045 6.46217 9.0222 6.46217 9.58571 6.46217Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const InboxIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 25" fill="none" {...props}>
    <path
      d="M4 6.5C4 5.96957 4.21071 5.46086 4.58579 5.08579C4.96086 4.71071 5.46957 4.5 6 4.5H18C18.5304 4.5 19.0391 4.71071 19.4142 5.08579C19.7893 5.46086 20 5.96957 20 6.5V18.5C20 19.0304 19.7893 19.5391 19.4142 19.9142C19.0391 20.2893 18.5304 20.5 18 20.5H6C5.46957 20.5 4.96086 20.2893 4.58579 19.9142C4.21071 19.5391 4 19.0304 4 18.5V6.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 13.5H7L10 16.5H14L17 13.5H20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const GoalsAndTargetsIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M11 12.5C11 12.7652 11.1054 13.0196 11.2929 13.2071C11.4804 13.3946 11.7348 13.5 12 13.5C12.2652 13.5 12.5196 13.3946 12.7071 13.2071C12.8946 13.0196 13 12.7652 13 12.5C13 12.2348 12.8946 11.9804 12.7071 11.7929C12.5196 11.6054 12.2652 11.5 12 11.5C11.7348 11.5 11.4804 11.6054 11.2929 11.7929C11.1054 11.9804 11 12.2348 11 12.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7.5C11.0111 7.5 10.0444 7.79324 9.22215 8.34265C8.39991 8.89206 7.75904 9.67295 7.3806 10.5866C7.00217 11.5002 6.90315 12.5055 7.09608 13.4755C7.289 14.4454 7.76521 15.3363 8.46447 16.0355C9.16373 16.7348 10.0546 17.211 11.0246 17.4039C11.9945 17.5969 12.9998 17.4978 13.9134 17.1194C14.827 16.741 15.6079 16.1001 16.1574 15.2779C16.7068 14.4556 17 13.4889 17 12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 3.55416C11.1461 3.34618 9.2733 3.71944 7.64079 4.62234C6.00827 5.52523 4.69667 6.91312 3.88743 8.59402C3.07818 10.2749 2.81128 12.1658 3.12365 14.005C3.43601 15.8442 4.31221 17.5409 5.63103 18.8604C6.94985 20.1799 8.64611 21.0569 10.4852 21.3702C12.3242 21.6835 14.2152 21.4176 15.8965 20.6092C17.5779 19.8008 18.9664 18.4899 19.8701 16.8578C20.7738 15.2258 21.148 13.3532 20.941 11.4992"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6.5V9.5H18L21 6.5H18V3.5L15 6.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9.5L12 12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const DigitalInsightsIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 25" fill="none" {...props}>
    <path
      d="M18.7471 16.3566V7.19772C18.7471 6.13722 17.8794 5.26953 16.8189 5.26953H12.4805"
      stroke="currentColor"
      strokeWidth="1.58471"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8923 2.85938L12 5.26962L14.8923 7.67986"
      stroke="currentColor"
      strokeWidth="1.58471"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 9.60742V16.3561"
      stroke="currentColor"
      strokeWidth="1.58471"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.49269 9.126C7.22317 9.126 8.626 7.72317 8.626 5.99269C8.626 4.26221 7.22317 2.85938 5.49269 2.85938C3.76221 2.85938 2.35938 4.26221 2.35938 5.99269C2.35938 7.72317 3.76221 9.126 5.49269 9.126Z"
      stroke="currentColor"
      strokeWidth="1.58471"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25166 22.14C6.84903 22.14 8.14395 20.8451 8.14395 19.2478C8.14395 17.6504 6.84903 16.3555 5.25166 16.3555C3.6543 16.3555 2.35938 17.6504 2.35938 19.2478C2.35938 20.8451 3.6543 22.14 5.25166 22.14Z"
      stroke="currentColor"
      strokeWidth="1.58471"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7497 22.14C20.3471 22.14 21.642 20.8451 21.642 19.2478C21.642 17.6504 20.3471 16.3555 18.7497 16.3555C17.1523 16.3555 15.8574 17.6504 15.8574 19.2478C15.8574 20.8451 17.1523 22.14 18.7497 22.14Z"
      stroke="currentColor"
      strokeWidth="1.58471"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const ConnectIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M3 15L5.625 12.375M11.25 3L8.625 5.625M15 6.75L12.375 9.375M7.33875 4.5L13.5 10.6613L11.9595 12.2017C11.5579 12.6194 11.077 12.9528 10.545 13.1824C10.013 13.412 9.44058 13.5332 8.86118 13.5389C8.28178 13.5445 7.70706 13.4346 7.17066 13.2155C6.63425 12.9964 6.14694 12.6725 5.73722 12.2628C5.3275 11.8531 5.00361 11.3657 4.7845 10.8293C4.56539 10.2929 4.45546 9.71822 4.46115 9.13882C4.46683 8.55942 4.58801 7.98698 4.8176 7.45497C5.04719 6.92297 5.38057 6.4421 5.79825 6.0405L7.33875 4.5Z"
      stroke="#92A5B8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const UserAddIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M14.25 15.75V11.25M12 13.5H16.5M9 11.25H6C4.60218 11.25 3.90326 11.25 3.35195 11.4784C2.61687 11.7828 2.03284 12.3669 1.72836 13.1019C1.5 13.6533 1.5 14.3522 1.5 15.75M11.625 2.46807C12.7244 2.91311 13.5 3.99098 13.5 5.25C13.5 6.50902 12.7244 7.58689 11.625 8.03193M10.125 5.25C10.125 6.90685 8.78185 8.25 7.125 8.25C5.46815 8.25 4.125 6.90685 4.125 5.25C4.125 3.59315 5.46815 2.25 7.125 2.25C8.78185 2.25 10.125 3.59315 10.125 5.25Z"
      stroke="#92A5B8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const UploadDataIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M3 12.75V14.25C3 14.6478 3.15804 15.0294 3.43934 15.3107C3.72064 15.592 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.592 14.5607 15.3107C14.842 15.0294 15 14.6478 15 14.25V12.75M5.25 6.75L9 3M9 3L12.75 6.75M9 3V12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const DatabaseIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20.2174 5.60817C20.2174 7.12089 16.5385 8.3472 12.0003 8.3472C7.46212 8.3472 3.7832 7.12089 3.7832 5.60817M20.2174 5.60817C20.2174 4.09545 16.5385 2.86914 12.0003 2.86914C7.46212 2.86914 3.7832 4.09545 3.7832 5.60817M20.2174 5.60817V18.3903C20.2174 19.9059 16.5653 21.1293 12.0003 21.1293C7.43524 21.1293 3.7832 19.9059 3.7832 18.3903V5.60817M20.2174 11.9992C20.2174 13.5148 16.5653 14.7383 12.0003 14.7383C7.43524 14.7383 3.7832 13.5148 3.7832 11.9992"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const ServerIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M19.2598 4.08203H4.7417C4.01278 4.08203 3.42188 4.67294 3.42188 5.40186V10.6812C3.42188 11.4101 4.01278 12.001 4.7417 12.001H19.2598C19.9887 12.001 20.5796 11.4101 20.5796 10.6812V5.40186C20.5796 4.67294 19.9887 4.08203 19.2598 4.08203Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.38062 8.70068C7.74507 8.70068 8.04053 8.40523 8.04053 8.04077C8.04053 7.67631 7.74507 7.38086 7.38062 7.38086C7.01616 7.38086 6.7207 7.67631 6.7207 8.04077C6.7207 8.40523 7.01616 8.70068 7.38062 8.70068Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6602 8.04102H17.2795"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.7417 12C4.39166 12 4.05596 12.1391 3.80844 12.3866C3.56093 12.6341 3.42188 12.9698 3.42188 13.3198V18.5991C3.42188 18.9492 3.56093 19.2849 3.80844 19.5324C4.05596 19.7799 4.39166 19.9189 4.7417 19.9189H19.2598C19.6098 19.9189 19.9455 19.7799 20.193 19.5324C20.4405 19.2849 20.5796 18.9492 20.5796 18.5991V13.3198C20.5796 12.9698 20.4405 12.6341 20.193 12.3866C19.9455 12.1391 19.6098 12 19.2598 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.38062 16.6206C7.74507 16.6206 8.04053 16.3252 8.04053 15.9607C8.04053 15.5962 7.74507 15.3008 7.38062 15.3008C7.01616 15.3008 6.7207 15.5962 6.7207 15.9607C6.7207 16.3252 7.01616 16.6206 7.38062 16.6206Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6602 15.959H17.2795"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const HandWithCoinIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M10.2501 6.10522C9.78188 6.43898 9.20896 6.63532 8.59018 6.63532C7.00922 6.63532 5.72759 5.3537 5.72759 3.77274C5.72759 2.19178 7.00922 0.910156 8.59018 0.910156C9.61497 0.910156 10.514 1.44866 11.0197 2.25814M4.09183 15.7033H6.22674C6.50509 15.7033 6.78175 15.7364 7.05159 15.8026L9.30737 16.3508C9.79683 16.4701 10.3067 16.4817 10.8013 16.3856L13.2954 15.9004C13.9543 15.772 14.5604 15.4565 15.0354 14.9945L16.8 13.2779C17.3039 12.7885 17.3039 11.9944 16.8 11.5042C16.3463 11.0629 15.6278 11.0132 15.1145 11.3875L13.0579 12.8879C12.7634 13.1032 12.405 13.2191 12.0364 13.2191H10.0505L11.3146 13.2191C12.0271 13.2191 12.6042 12.6576 12.6042 11.9646V11.7137C12.6042 11.1382 12.2016 10.6364 11.6278 10.4972L9.67681 10.0228C9.35929 9.94576 9.03412 9.90684 8.70725 9.90684C7.91815 9.90684 6.48977 10.5602 6.48977 10.5602L4.09183 11.5629M15.5422 4.59062C15.5422 6.17158 14.2605 7.4532 12.6796 7.4532C11.0986 7.4532 9.817 6.17158 9.817 4.59062C9.817 3.00966 11.0986 1.72804 12.6796 1.72804C14.2605 1.72804 15.5422 3.00966 15.5422 4.59062ZM0.820313 11.2154L0.820313 15.9592C0.820312 16.4172 0.820312 16.6462 0.909456 16.8212C0.987869 16.9751 1.11299 17.1002 1.26688 17.1786C1.44184 17.2678 1.67086 17.2678 2.12892 17.2678H2.78322C3.24128 17.2678 3.47031 17.2678 3.64526 17.1786C3.79916 17.1002 3.92428 16.9751 4.00269 16.8212C4.09183 16.6462 4.09183 16.4172 4.09183 15.9592V11.2154C4.09183 10.7574 4.09183 10.5284 4.00269 10.3534C3.92428 10.1995 3.79916 10.0744 3.64526 9.99598C3.47031 9.90684 3.24128 9.90684 2.78323 9.90684L2.12892 9.90684C1.67087 9.90684 1.44184 9.90684 1.26688 9.99598C1.11299 10.0744 0.987869 10.1995 0.909456 10.3534C0.820313 10.5284 0.820313 10.7574 0.820313 11.2154Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const FingerOnDollarIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M9.07835 5.41094C9.01733 5.23831 8.92318 5.08134 8.80354 4.94766C8.54904 4.66332 8.17921 4.48438 7.76759 4.48438H6.6918C6.00662 4.48438 5.45117 5.03982 5.45117 5.725C5.45117 6.30802 5.85713 6.81238 6.42668 6.93696L8.06459 7.29526C8.70265 7.43483 9.15743 8.00027 9.15743 8.65341C9.15743 9.421 8.53518 10.0438 7.76759 10.0438H6.84102C6.23587 10.0438 5.72105 9.65702 5.53026 9.1172"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.30859 4.48555V3.0957"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.30859 11.4348V10.0449"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.95898 19.032V11.7353C9.95898 11.2746 10.142 10.8327 10.4678 10.5069C10.7936 10.1811 11.2355 9.99805 11.6963 9.99805V9.99805C12.157 9.99805 12.5989 10.1811 12.9247 10.5069C13.2506 10.8327 13.4336 11.2746 13.4336 11.7353V15.5574H16.2133C16.9505 15.5574 17.6575 15.8503 18.1788 16.3716C18.7001 16.8929 18.993 17.5999 18.993 18.3371V19.032"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.30748 13.5622C3.82935 13.5622 1.00977 10.7426 1.00977 7.26451C1.00977 3.78638 3.82935 0.966797 7.30748 0.966797C10.7856 0.966797 13.6052 3.78638 13.6052 7.26451C13.6052 7.5569 13.5853 7.84464 13.5467 8.12644"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </ChakraIcon>
);

const TagIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M5.78526 5.78526H5.79324M1 3.55214L1 7.12076C1 7.5109 1 7.70598 1.04407 7.88955C1.08315 8.05231 1.1476 8.2079 1.23505 8.35062C1.33369 8.51159 1.47163 8.64952 1.7475 8.9254L7.86357 15.0415C8.81109 15.989 9.28485 16.4627 9.83116 16.6403C10.3117 16.7964 10.8293 16.7964 11.3099 16.6403C11.8562 16.4627 12.33 15.989 13.2775 15.0415L15.0415 13.2775C15.989 12.33 16.4627 11.8562 16.6403 11.3099C16.7964 10.8293 16.7964 10.3117 16.6403 9.83116C16.4627 9.28485 15.989 8.81109 15.0415 7.86357L8.9254 1.7475C8.64952 1.47163 8.51159 1.33369 8.35062 1.23505C8.2079 1.1476 8.05231 1.08315 7.88955 1.04407C7.70598 1 7.5109 1 7.12076 1L3.55214 1C2.65881 1 2.21214 1 1.87093 1.17385C1.5708 1.32678 1.32678 1.5708 1.17385 1.87093C1 2.21214 1 2.65881 1 3.55214ZM6.18404 5.78526C6.18404 6.0055 6.0055 6.18403 5.78526 6.18403C5.56503 6.18403 5.38649 6.0055 5.38649 5.78526C5.38649 5.56503 5.56503 5.38649 5.78526 5.38649C6.0055 5.38649 6.18404 5.56503 6.18404 5.78526Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const ArrowDiagonalDownIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 16 17" fill="none" {...props}>
    <path
      d="M4.25911 4.76076L11.7404 12.242M11.7404 12.242V7.62515M11.7404 12.242H7.12351"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const ArrowDiagonalUpIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 16 17" fill="none" {...props}>
    <path
      d="M4.25881 12.2409L11.7401 4.75961M11.7401 4.75961H7.1232M11.7401 4.75961V9.37649"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const LogoutIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 119 119" fill="none" {...props}>
    <path
      d="M12.6252 59.8889C12.6252 37.8704 12.6252 26.8611 19.4655 20.0209C26.3058 13.1806 37.3151 13.1806 59.3336 13.1806C81.3519 13.1806 92.3613 13.1806 99.2018 20.0209C106.042 26.8611 106.042 37.8704 106.042 59.8889C106.042 81.9072 106.042 92.9166 99.2018 99.7567C92.3613 106.597 81.3519 106.597 59.3336 106.597C37.3151 106.597 26.3058 106.597 19.4655 99.7567C12.6252 92.9166 12.6252 81.9072 12.6252 59.8889Z"
      stroke="currentColor"
      strokeWidth="8.5"
    />
    <path
      d="M34.9326 60.0251H69.2293M69.2293 60.0251C69.2293 62.8301 58.6329 72.2548 58.6329 72.2548M69.2293 60.0251C69.2293 57.1474 58.6329 47.9087 58.6329 47.9087M84.0992 40.1995V79.533"
      stroke="currentColor"
      strokeWidth="8.5"
      strokeLinecap="round"
    />
  </ChakraIcon>
);

const ArrowGraphIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M3 17L9 11L13 15L21 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 7H21V14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const ArrowSwitchIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20 17.5H4M4 17.5L8 13.5M4 17.5L8 21.5M4 7.5H20M20 7.5L16 3.5M20 7.5L16 11.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const SparkleIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M7.35975 11.928L6.75 14.0625L6.14025 11.928C5.98265 11.3766 5.68717 10.8745 5.28169 10.4691C4.87621 10.0636 4.37411 9.7681 3.82275 9.6105L1.6875 9L3.822 8.39025C4.37336 8.23265 4.87546 7.93717 5.28094 7.53169C5.68642 7.12621 5.9819 6.62411 6.1395 6.07275L6.75 3.9375L7.35975 6.072C7.51735 6.62335 7.81283 7.12546 8.21831 7.53094C8.62379 7.93642 9.12589 8.2319 9.67725 8.3895L11.8125 9L9.678 9.60975C9.12665 9.76735 8.62454 10.0628 8.21906 10.4683C7.81358 10.8738 7.5181 11.3759 7.3605 11.9272L7.35975 11.928ZM13.6943 6.53625L13.5 7.3125L13.3057 6.53625C13.1946 6.09119 12.9645 5.68472 12.6402 5.36027C12.3159 5.03583 11.9095 4.80562 11.4645 4.69425L10.6875 4.5L11.4645 4.30575C11.9095 4.19438 12.3159 3.96417 12.6402 3.63973C12.9645 3.31528 13.1946 2.90881 13.3057 2.46375L13.5 1.6875L13.6943 2.46375C13.8055 2.9089 14.0357 3.31544 14.3601 3.63989C14.6846 3.96434 15.0911 4.1945 15.5363 4.30575L16.3125 4.5L15.5363 4.69425C15.0911 4.8055 14.6846 5.03566 14.3601 5.36011C14.0357 5.68456 13.8055 6.0911 13.6943 6.53625Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1508 15.1004L13.3281 14.568C13.3778 14.4189 13.4615 14.2834 13.5727 14.1723C13.6838 14.0611 13.8193 13.9774 13.9684 13.9277L14.5008 13.7504L13.9684 13.5731C13.8193 13.5234 13.6838 13.4396 13.5727 13.3285C13.4615 13.2174 13.3778 13.0819 13.3281 12.9327L13.1508 12.4004L12.9735 12.9327C12.9238 13.0819 12.84 13.2174 12.7289 13.3285C12.6177 13.4396 12.4822 13.5234 12.3331 13.5731L11.8008 13.7504L12.3331 13.9277C12.4822 13.9774 12.6177 14.0611 12.7289 14.1723C12.84 14.2834 12.9238 14.4189 12.9735 14.568L13.1508 15.1004Z"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const Dv360Icon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <g clipPath="url(#clip0_3491_8307)">
      <path
        d="M12.2602 6.68944C13.2698 6.07988 14.5847 6.39981 15.1968 7.404C15.8096 8.40819 15.488 9.7161 14.4784 10.325C14.4515 10.3412 14.4246 10.3567 14.3977 10.3715L3.25977 16.751C2.2502 17.3606 0.935277 17.0407 0.322449 16.0365C-0.290379 15.0323 0.0312667 13.7244 1.04084 13.1148C1.06776 13.0986 1.09468 13.0831 1.1216 13.0683L12.2602 6.68944Z"
        fill="#81C995"
      />
      <path
        d="M4.25813 2.14002C4.26309 0.968115 3.31161 0.0132566 2.13342 0.00832377C1.98181 0.00761907 1.8309 0.0231223 1.68212 0.0541288C0.683887 0.297952 -0.0139575 1.19432 0.000211891 2.21754V14.8886L4.25388 14.9654L4.25813 2.14002Z"
        fill="#34A853"
      />
      <path
        d="M12.3103 10.3792C13.3397 10.9099 14.6065 10.5702 15.2285 9.59633C15.8265 8.59567 15.4956 7.30185 14.4896 6.70709C14.4818 6.70286 14.4747 6.69863 14.4669 6.6937L3.25465 0.302845C2.25641 -0.296849 0.957785 0.0216724 0.354167 1.01458C0.339289 1.03925 0.324412 1.06462 0.310242 1.08999C-0.28204 2.0984 0.059443 3.39433 1.07327 3.98416C1.08035 3.98839 1.08744 3.99191 1.09452 3.99614L12.3103 10.3792Z"
        fill="#5BB974"
      />
      <path
        d="M14.3934 10.3939L4.25586 16.0265V11.1881L12.2998 6.72668C13.3661 6.13897 14.7101 6.52232 15.3009 7.58359C15.3562 7.68225 15.403 7.78513 15.4419 7.89084C15.7437 8.86684 15.3031 9.91894 14.3934 10.3939Z"
        fill="#81C995"
      />
      <path
        d="M2.13074 17.1099C3.30536 17.1099 4.25757 16.1627 4.25757 14.9944C4.25757 13.826 3.30536 12.8789 2.13074 12.8789C0.956121 12.8789 0.00390625 13.826 0.00390625 14.9944C0.00390625 16.1627 0.956121 17.1099 2.13074 17.1099Z"
        fill="#1E8E3E"
      />
    </g>
    <defs>
      <clipPath id="clip0_3491_8307">
        <rect width="15.5347" height="17.1106" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const PinterestIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M8.81573 -0.000108719C3.94696 -0.000108719 0 3.94685 0 8.81562C0 12.5504 2.32367 15.7431 5.60305 17.0276C5.52602 16.3301 5.45635 15.2574 5.63362 14.496C5.79383 13.808 6.66737 10.114 6.66737 10.114C6.66737 10.114 6.40367 9.58589 6.40367 8.80514C6.40367 7.57931 7.11418 6.66415 7.99885 6.66415C8.75098 6.66415 9.11425 7.22883 9.11425 7.90595C9.11425 8.66235 8.63268 9.79322 8.38416 10.8412C8.17647 11.7186 8.82418 12.4342 9.68963 12.4342C11.2565 12.4342 12.4609 10.7821 12.4609 8.39728C12.4609 6.2865 10.9442 4.81071 8.77851 4.81071C6.27013 4.81071 4.79781 6.69212 4.79781 8.63648C4.79781 9.39417 5.08968 10.2066 5.4539 10.6483C5.52595 10.7356 5.5365 10.8121 5.51503 10.9012C5.44812 11.1796 5.2994 11.7784 5.2702 11.901C5.23176 12.0623 5.14244 12.0966 4.97536 12.0188C3.87433 11.5063 3.18594 9.89656 3.18594 8.60359C3.18594 5.8227 5.20646 3.26879 9.01084 3.26879C12.069 3.26879 14.4456 5.44801 14.4456 8.36035C14.4456 11.3986 12.5299 13.8437 9.87101 13.8437C8.97767 13.8437 8.13789 13.3796 7.85042 12.8314C7.85042 12.8314 7.40837 14.5146 7.3012 14.9271C7.10219 15.6928 6.5649 16.6527 6.20552 17.2382C7.03035 17.4936 7.90693 17.6313 8.81573 17.6313C13.6846 17.6313 17.6315 13.6844 17.6315 8.81562C17.6315 3.94685 13.6846 -0.000108719 8.81573 -0.000108719Z"
      fill="#E60023"
    />
  </ChakraIcon>
);

const TiktokIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 20 20" fill="none" {...props}>
    <g clipPath="url(#clip0_3491_7742)">
      <path
        d="M15.234 0.695312H4.76615C2.51789 0.695312 0.695312 2.51789 0.695312 4.76615V15.234C0.695312 17.4823 2.51789 19.3048 4.76615 19.3048H15.234C17.4823 19.3048 19.3048 17.4823 19.3048 15.234V4.76615C19.3048 2.51789 17.4823 0.695312 15.234 0.695312Z"
        fill="black"
      />
      <path
        d="M14.9067 5.68581C14.8049 5.63322 14.7059 5.57557 14.6099 5.51307C14.3308 5.32853 14.0748 5.11109 13.8476 4.86542C13.2791 4.21496 13.0668 3.55506 12.9886 3.09306H12.9917C12.9264 2.70955 12.9534 2.46143 12.9575 2.46143H10.3682V12.4738C10.3682 12.6082 10.3682 12.7411 10.3625 12.8724C10.3625 12.8887 10.361 12.9038 10.36 12.9213C10.36 12.9286 10.36 12.9361 10.3585 12.9437C10.3585 12.9455 10.3585 12.9474 10.3585 12.9493C10.3312 13.3085 10.216 13.6556 10.0231 13.9599C9.83022 14.2642 9.5655 14.5164 9.25226 14.6944C8.92578 14.8801 8.55654 14.9775 8.18092 14.977C6.97451 14.977 5.99678 13.9933 5.99678 12.7784C5.99678 11.5636 6.97451 10.5799 8.18092 10.5799C8.40929 10.5796 8.63625 10.6156 8.85338 10.6863L8.85652 8.04992C8.19737 7.96478 7.52772 8.01716 6.88984 8.20376C6.25194 8.39037 5.65965 8.70716 5.15032 9.13414C4.70404 9.52189 4.32884 9.98457 4.04161 10.5013C3.9323 10.6898 3.51991 11.447 3.46997 12.6761C3.43857 13.3736 3.64806 14.0963 3.74793 14.395V14.4013C3.81076 14.5772 4.05418 15.1774 4.45087 15.6834C4.77074 16.0893 5.14865 16.4458 5.57246 16.7416V16.7353L5.57874 16.7416C6.83225 17.5933 8.22207 17.5374 8.22207 17.5374C8.46266 17.5277 9.26858 17.5374 10.1838 17.1037C11.199 16.6228 11.7769 15.9064 11.7769 15.9064C12.1461 15.4783 12.4396 14.9905 12.645 14.4638C12.8793 13.8479 12.9575 13.1092 12.9575 12.8139V7.50216C12.9889 7.521 13.4073 7.7977 13.4073 7.7977C13.4073 7.7977 14.01 8.18402 14.9504 8.43562C15.625 8.61464 16.534 8.65232 16.534 8.65232V6.08186C16.2155 6.11641 15.5688 6.01592 14.9067 5.68581Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3491_7742">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const XLogoIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M15.234 0.695312H4.76615C2.51789 0.695312 0.695312 2.51789 0.695312 4.76615V15.234C0.695312 17.4823 2.51789 19.3048 4.76615 19.3048H15.234C17.4823 19.3048 19.3048 17.4823 19.3048 15.234V4.76615C19.3048 2.51789 17.4823 0.695312 15.234 0.695312Z"
      fill="black"
    />
    <path
      d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"
      fill="white"
      transform="translate(4.72 4.72) scale(0.44)"
    />
  </ChakraIcon>
);

const SnapchatIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <g clipPath="url(#clip0_3491_3285)">
      <path
        d="M0.0078125 14.913V14.9139C0.0197822 15.3579 0.0234743 15.8044 0.0983629 16.2457C0.177721 16.7125 0.291161 17.1677 0.507588 17.5914C0.800186 18.1648 1.20203 18.6491 1.70926 19.0447C2.07345 19.3287 2.47129 19.5542 2.91168 19.6964C3.55385 19.9036 4.21634 19.983 4.88851 19.9869C5.30788 19.9895 5.72698 20 6.1465 19.9982C9.19315 19.9854 12.2399 20.0202 15.2866 19.9794C15.6909 19.974 16.0886 19.9246 16.4854 19.8521C17.2459 19.7129 17.918 19.3884 18.4931 18.8753C19.1632 18.2776 19.6154 17.546 19.8195 16.6631C19.9531 16.086 19.9865 15.5005 19.9922 14.9129V14.7957C19.9922 14.7503 19.9749 4.81219 19.9733 4.68083C19.9689 4.31999 19.9423 3.96187 19.8746 3.60682C19.7924 3.17416 19.6761 2.75257 19.4689 2.36115C19.2502 1.94761 18.9762 1.57577 18.6372 1.25084C18.1181 0.753006 17.519 0.400948 16.8215 0.214717C16.1915 0.0465577 15.5489 0.00932711 14.9015 0.00991005C14.9004 0.0097546 14.898 0.00318675 14.8978 0H5.09911C5.09892 0.0033422 5.0988 0.00668444 5.09857 0.00991005C4.73116 0.0166333 4.3632 0.013874 3.99766 0.059188C3.59722 0.108971 3.20062 0.183938 2.8216 0.323921C2.22459 0.54474 1.70588 0.888676 1.26281 1.34784C0.760818 1.86806 0.406972 2.46969 0.219226 3.17027C0.0517276 3.79534 0.0152744 4.43285 0.0143806 5.07486"
        fill="#FFFC00"
      />
      <path
        d="M10.0903 16.8741C10.0488 16.8741 10.0092 16.8725 9.97904 16.8711C9.95514 16.8732 9.93046 16.8741 9.90574 16.8741C9.03378 16.8741 8.45076 16.4618 7.93626 16.0979C7.56749 15.8374 7.2197 15.5914 6.81227 15.5237C6.61216 15.4905 6.41311 15.4736 6.22077 15.4736C5.87423 15.4736 5.60037 15.5274 5.40042 15.5665C5.27738 15.5905 5.17128 15.6111 5.08928 15.6111C5.0034 15.6111 4.89905 15.5921 4.85556 15.4436C4.82109 15.3264 4.79637 15.2129 4.77251 15.1037C4.71282 14.8306 4.66953 14.6639 4.56728 14.6481C3.47364 14.4793 2.82747 14.2308 2.69876 13.9297C2.68527 13.8981 2.67773 13.8663 2.67606 13.8348C2.67105 13.7451 2.73439 13.6664 2.82284 13.6517C3.69135 13.5087 4.46359 13.0496 5.11824 12.2869C5.62536 11.6964 5.87439 11.1322 5.90113 11.0699C5.90229 11.0671 5.90365 11.0641 5.90505 11.0614C6.03124 10.8054 6.05634 10.5842 5.9799 10.404C5.83898 10.0717 5.37228 9.92364 5.06352 9.82567C4.98672 9.80138 4.91409 9.77837 4.85622 9.7554C4.58251 9.64729 4.13237 9.41885 4.19233 9.10356C4.23601 8.87365 4.54011 8.71353 4.78588 8.71353C4.85412 8.71353 4.9146 8.7255 4.96551 8.7494C5.24322 8.87951 5.49307 8.94546 5.70794 8.94546C5.97516 8.94546 6.10422 8.84372 6.13543 8.81481C6.12774 8.67226 6.11833 8.52155 6.10924 8.379C6.10924 8.37884 6.10904 8.37713 6.10904 8.37713C6.04632 7.37933 5.96809 6.13759 6.28571 5.42551C7.23638 3.294 9.25246 3.12825 9.84753 3.12825C9.86338 3.12825 10.1069 3.12584 10.1069 3.12584C10.1179 3.12564 10.1298 3.12549 10.1422 3.12549C10.7389 3.12549 12.7592 3.29143 13.7104 5.42422C14.028 6.13677 13.9497 7.37957 13.8868 8.37842L13.8839 8.42622C13.8752 8.56185 13.8673 8.69021 13.8605 8.81465C13.8899 8.8417 14.008 8.93497 14.2483 8.94442C14.4532 8.93657 14.6886 8.87093 14.9478 8.74956C15.0279 8.71194 15.1166 8.70413 15.1769 8.70413C15.2679 8.70413 15.3606 8.72185 15.4378 8.75407L15.4419 8.75566C15.6619 8.83373 15.8059 8.98977 15.809 9.15369C15.8118 9.3065 15.6982 9.5349 15.1397 9.75548C15.0825 9.77814 15.0095 9.8013 14.9324 9.82575C14.6234 9.92383 14.1571 10.0718 14.0161 10.4039C13.9396 10.5841 13.9648 10.8052 14.091 11.0612C14.0924 11.064 14.0936 11.0668 14.095 11.0698C14.1338 11.1609 15.0745 13.3058 17.1732 13.6515C17.2617 13.6662 17.3251 13.745 17.3201 13.8346C17.3182 13.8668 17.3104 13.899 17.2968 13.9304C17.169 14.2298 16.5229 14.478 15.4289 14.6469C15.3262 14.6628 15.283 14.8287 15.2238 15.1004C15.1994 15.2126 15.1745 15.3226 15.1404 15.4382C15.1086 15.5469 15.0378 15.6 14.9241 15.6H14.907C14.8329 15.6 14.728 15.5865 14.5957 15.5607C14.3645 15.5156 14.1052 15.4738 13.7754 15.4738C13.5831 15.4738 13.3841 15.4906 13.1837 15.5238C12.7767 15.5915 12.429 15.8371 12.0609 16.0973C11.5454 16.4618 10.9622 16.8741 10.0903 16.8741Z"
        fill="white"
      />
      <path
        d="M10.1422 3.30144C10.7039 3.30144 12.6384 3.45234 13.55 5.4961C13.8501 6.16908 13.7732 7.38817 13.7115 8.36748C13.7018 8.52289 13.6923 8.67352 13.6845 8.81735L13.6813 8.87918L13.7225 8.92523C13.7392 8.94373 13.8952 9.1068 14.2423 9.12021L14.2479 9.12052L14.2537 9.1204C14.4831 9.11166 14.7416 9.04038 15.0223 8.90891C15.0636 8.88956 15.1186 8.88011 15.1768 8.88011C15.2432 8.88011 15.3137 8.89259 15.3718 8.91707L15.3806 8.92057C15.5278 8.97214 15.6318 9.06938 15.6334 9.15736C15.6343 9.20711 15.5971 9.3863 15.0754 9.59239C15.0244 9.61252 14.9573 9.63394 14.8795 9.65846C14.54 9.76626 14.0271 9.92894 13.8544 10.3357C13.7572 10.5649 13.7838 10.8353 13.9335 11.1393C13.995 11.283 14.9641 13.4658 17.1447 13.8252C17.1443 13.8355 17.1417 13.8468 17.1358 13.8601C17.0989 13.9472 16.864 14.248 15.4021 14.4735C15.1733 14.5086 15.1173 14.765 15.0523 15.0631C15.0289 15.1698 15.005 15.2775 14.9722 15.3888C14.9622 15.4224 14.9603 15.4243 14.9243 15.4243C14.9193 15.4243 14.9135 15.4243 14.9071 15.4243C14.8423 15.4243 14.7439 15.4109 14.6298 15.3885C14.4221 15.348 14.1383 15.2984 13.7755 15.2984C13.5731 15.2984 13.3645 15.316 13.1552 15.3509C12.7079 15.4253 12.3441 15.6826 11.9588 15.955C11.4414 16.3206 10.9066 16.6989 10.0906 16.6989C10.055 16.6989 10.0202 16.6977 9.98532 16.696L9.97615 16.6956L9.96694 16.6963C9.94692 16.698 9.92675 16.6989 9.90616 16.6989C9.09031 16.6989 8.55529 16.3207 8.0381 15.955C7.65274 15.6826 7.28875 15.4253 6.84148 15.3509C6.63239 15.3161 6.42362 15.2984 6.22126 15.2984C5.85856 15.2984 5.57443 15.3539 5.36714 15.3944C5.25308 15.4167 5.15433 15.4358 5.0897 15.4358C5.03677 15.4358 5.03575 15.4327 5.02456 15.3945C4.99176 15.2831 4.96778 15.1729 4.94443 15.0663C4.87929 14.7679 4.82321 14.5101 4.59458 14.475C3.13284 14.2492 2.89787 13.948 2.8608 13.8612C2.85501 13.8475 2.8524 13.8358 2.85182 13.8255C5.03241 13.4665 6.0013 11.2835 6.06305 11.1393C6.21295 10.8355 6.23953 10.5651 6.14202 10.3357C5.96939 9.92918 5.45656 9.76626 5.11729 9.65865C5.03929 9.63398 4.97214 9.61252 4.92111 9.59239C4.48056 9.41833 4.34505 9.24298 4.36518 9.13672C4.38853 9.01419 4.60096 8.8896 4.78633 8.8896C4.82799 8.8896 4.86453 8.89632 4.89154 8.90895C5.19261 9.05006 5.46744 9.12161 5.70851 9.12161C6.08746 9.12161 6.25612 8.94529 6.27423 8.92516L6.31531 8.87922L6.31201 8.8177C6.30435 8.67395 6.29491 8.52335 6.28496 8.36825C6.22344 7.38872 6.14649 6.17044 6.44655 5.49742C7.35478 3.46116 9.27977 3.3042 9.84802 3.3042C9.86201 3.3042 10.1091 3.30167 10.1091 3.30167C10.1192 3.30159 10.1304 3.30144 10.1422 3.30144ZM10.1422 2.9502H10.1415C10.1286 2.9502 10.1164 2.9502 10.1048 2.95035C10.0125 2.95128 9.86069 2.95276 9.84705 2.95292C9.51415 2.95292 8.84808 2.99994 8.13262 3.31574C7.72355 3.49618 7.35559 3.74016 7.03902 4.04092C6.66158 4.39927 6.3541 4.8411 6.12527 5.35433C5.79016 6.10578 5.86971 7.3715 5.9336 8.38866L5.93384 8.39025C5.94068 8.49918 5.94786 8.61293 5.95443 8.72377C5.90527 8.74635 5.82556 8.77017 5.70808 8.77017C5.51905 8.77017 5.29427 8.70974 5.04015 8.59066C4.96537 8.55584 4.88003 8.53824 4.78587 8.53824C4.63457 8.53824 4.47508 8.58278 4.33673 8.66412C4.16266 8.76632 4.05019 8.91078 4.01965 9.07093C3.99952 9.17687 4.00049 9.38626 4.23308 9.59861C4.36102 9.71551 4.54896 9.82331 4.79154 9.91919C4.8552 9.94426 4.93075 9.96819 5.01077 9.99357C5.28844 10.0818 5.7087 10.2152 5.8183 10.4731C5.87383 10.6039 5.84993 10.776 5.74745 10.984C5.74477 10.9896 5.74209 10.9952 5.73964 11.001C5.71403 11.0608 5.4751 11.602 4.985 12.1728C4.70651 12.4974 4.39976 12.7686 4.07378 12.9793C3.67591 13.2364 3.24538 13.4046 2.7943 13.4789C2.61717 13.5079 2.49067 13.6658 2.50054 13.8451C2.50357 13.8968 2.5157 13.9483 2.53672 13.9982C2.53688 13.9985 2.53707 13.9988 2.53723 13.9991C2.60885 14.1666 2.77491 14.3089 3.04489 14.4345C3.3748 14.5877 3.8682 14.7166 4.51126 14.8175C4.54375 14.8792 4.57748 15.0345 4.60084 15.1409C4.62529 15.2539 4.65078 15.3701 4.68712 15.4935C4.72633 15.6272 4.82803 15.787 5.08931 15.787C5.18833 15.787 5.3022 15.7647 5.43406 15.7392C5.62717 15.7013 5.89124 15.6496 6.22084 15.6496C6.40357 15.6496 6.59295 15.6657 6.78357 15.6973C7.15102 15.7585 7.46779 15.9823 7.8343 16.2414C8.37077 16.6207 8.978 17.0499 9.90577 17.0499C9.93107 17.0499 9.95645 17.0491 9.98151 17.0473C10.0122 17.0488 10.0502 17.0499 10.0903 17.0499C11.0183 17.0499 11.6254 16.6205 12.1613 16.2416L12.1621 16.2408C12.5287 15.982 12.8452 15.7585 13.2125 15.6973C13.403 15.6657 13.5924 15.6496 13.7752 15.6496C14.09 15.6496 14.3394 15.6897 14.562 15.7331C14.7072 15.7617 14.8201 15.7755 14.9067 15.7755L14.9152 15.7757H14.924C15.1151 15.7757 15.2555 15.6708 15.3091 15.4872C15.3447 15.3664 15.3701 15.2529 15.3952 15.138C15.417 15.0384 15.4519 14.8786 15.4844 14.8162C16.1279 14.7151 16.6211 14.5865 16.951 14.4333C17.2204 14.3084 17.3863 14.1662 17.4583 13.9994C17.4799 13.9493 17.4926 13.8975 17.4954 13.8447C17.5055 13.6657 17.3789 13.5075 17.2016 13.4785C15.1969 13.1481 14.2937 11.0882 14.2564 11.0007C14.254 10.9949 14.2513 10.9892 14.2484 10.9836C14.1459 10.7756 14.1223 10.6037 14.1778 10.4727C14.2872 10.215 14.7072 10.0816 14.9851 9.99342C15.0655 9.96808 15.1413 9.94398 15.2045 9.91903C15.478 9.811 15.6736 9.69379 15.8025 9.56068C15.9566 9.402 15.9866 9.24997 15.9847 9.15048C15.98 8.90977 15.796 8.69587 15.5033 8.59113C15.4044 8.55025 15.2917 8.52868 15.1769 8.52868C15.0987 8.52868 14.983 8.5394 14.8734 8.59055C14.6389 8.7003 14.4288 8.7603 14.2485 8.76885C14.1525 8.76399 14.0853 8.7432 14.0417 8.72334C14.0472 8.62945 14.0532 8.53299 14.0595 8.43242L14.0621 8.38936C14.1263 7.37154 14.2062 6.10484 13.8709 5.35285C13.6411 4.8378 13.3325 4.39484 12.9536 4.03571C12.6358 3.73476 12.2666 3.49082 11.856 3.31049C11.1416 2.99703 10.4755 2.9502 10.1422 2.9502Z"
        fill="#020202"
      />
    </g>
    <defs>
      <clipPath id="clip0_3491_3285">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const Cv360Icon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M8.0498 8.01747C8.27675 8.01275 8.49851 7.97889 8.72716 7.98897C9.91437 8.04134 11.1009 8.36946 12.1434 8.94591C12.6251 9.21226 13.0219 9.57234 13.4686 9.88549C13.4139 9.7399 13.3199 9.61389 13.2587 9.47037C13.1142 9.13176 13.0414 8.77111 13.0575 8.40293C13.1163 7.05182 14.3834 5.98227 15.7068 6.12495C16.1016 6.1675 16.5071 6.33474 16.8259 6.56928C16.9875 6.68815 17.115 6.84144 17.2677 6.97004C17.5074 7.17203 17.7943 7.3408 18.0923 7.43868C19.1788 7.79559 20.4627 7.35459 21.0534 6.357C21.3934 5.78275 21.4744 5.10905 21.3562 4.45933C21.2166 3.69193 20.6455 3.14605 20.0654 2.68038C18.7248 1.60421 17.0843 1.0791 15.3829 1.0791C12.531 1.0791 9.89776 2.79634 8.7068 5.40817C8.47062 5.92608 8.29059 6.47852 8.1856 7.03898C8.12484 7.36342 8.10941 7.69421 8.0498 8.01747Z"
      fill="#1E8E3E"
    />
    <path
      d="M21.0377 3.65869C21.1828 4.06005 21.4001 4.40213 21.4194 4.84474C21.4786 6.20513 20.4261 7.50791 19.0351 7.57149C18.6309 7.58996 18.2214 7.50536 17.8571 7.32778C17.6646 7.23394 17.4951 7.0858 17.2976 7.00927C17.6276 7.54765 17.8696 8.04786 17.825 8.69939C17.7425 9.90672 16.5555 11.0381 15.3244 10.9182C14.9004 10.8769 14.4618 10.7438 14.117 10.4855C13.8092 10.2551 13.5611 9.9418 13.2629 9.69608C12.6678 9.20571 11.9858 8.78226 11.2603 8.51736C10.5827 8.26995 9.8615 8.07099 9.13991 8.02005C6.18443 7.81151 3.28066 9.39376 1.94684 12.0796C1.65112 12.6751 1.39984 13.3168 1.28958 13.9773C0.941635 16.0615 1.32185 18.1901 2.59111 19.9075C2.78513 20.1701 3.00165 20.4048 3.21666 20.6488C3.28987 20.7318 3.34224 20.8341 3.4282 20.9053C4.61963 21.8919 6.51491 21.6997 7.41058 20.4116C7.57043 20.1816 7.6897 19.9163 7.74734 19.6407C7.86172 19.0934 7.75821 18.5348 7.51221 18.0395C7.40969 17.8331 7.19603 17.6339 7.13731 17.4168C6.90165 17.2497 6.70696 17.0053 6.54843 16.7645C6.30455 16.3941 6.14128 15.9081 6.14128 15.4598C6.14128 13.7148 8.16344 12.4905 9.67001 13.3684C9.96413 13.5398 10.2117 13.7871 10.4063 14.0662C10.6524 14.1228 10.9079 14.4279 11.1131 14.5813C11.5133 14.8805 11.9562 15.1234 12.4089 15.3321C14.1418 16.131 16.2197 16.1764 18.0044 15.5176C18.6634 15.2743 19.2973 14.9382 19.8597 14.5141C22.3474 12.6385 23.3927 9.37952 22.5397 6.3866C22.3349 5.66833 22.0191 4.99225 21.6071 4.37032C21.4452 4.12596 21.2748 3.83437 21.0377 3.65869Z"
      fill="#5BB974"
    />
    <path
      d="M15.2961 6.13241C14.4334 6.24648 13.6907 6.66035 13.3029 7.48379C12.9992 8.12897 12.9999 8.94989 13.3173 9.58902C13.7482 10.4566 14.7204 11.0006 15.679 10.8852C16.659 10.7672 17.5042 10.1016 17.7435 9.1146C18.0587 7.81428 17.2699 6.44973 15.944 6.17926C15.737 6.13703 15.5062 6.10465 15.2961 6.13241Z"
      fill="var(--chakra-colors-surface-panel)"
    />
    <path
      d="M8.22604 13.1006C7.84779 13.1601 7.48096 13.293 7.16584 13.5157C6.31167 14.1195 5.95916 15.2365 6.28499 16.2306C6.41331 16.6221 6.64496 16.9451 6.92759 17.2376C7.18825 17.5073 7.50955 17.6957 7.87264 17.7935C8.17624 17.8753 8.53332 17.8936 8.84449 17.8487C9.20646 17.7965 9.53969 17.6762 9.84579 17.4736C11.2648 16.5342 11.1873 14.3042 9.75744 13.4157C9.52178 13.2692 9.26342 13.176 8.99174 13.125C8.74722 13.079 8.47301 13.0617 8.22604 13.1006Z"
      fill="var(--chakra-colors-surface-panel)"
    />
    <path
      d="M10.4354 14.0366C10.4914 14.1855 10.5938 14.3081 10.6616 14.4517C10.831 14.8107 10.9229 15.2104 10.9055 15.6081C10.8482 16.9118 9.62488 17.979 8.34445 17.8886C7.87181 17.8553 7.53148 17.608 7.10755 17.4465C7.40267 17.8962 7.72453 18.3421 7.77987 18.8994C7.91934 20.3036 6.71186 21.4431 5.37 21.5357C4.90171 21.568 4.43437 21.4585 4.0153 21.2475C3.84075 21.1597 3.69138 21.0245 3.51465 20.9453C3.67353 21.2237 4.0527 21.4403 4.3098 21.623C5.16886 22.2336 6.18962 22.643 7.22535 22.8157C9.65168 23.2204 12.2102 22.4541 13.9079 20.6192C14.4748 20.0064 14.9394 19.3048 15.2856 18.5436C15.6544 17.7325 15.8437 16.8493 15.9131 15.9639C15.5733 15.9639 15.2206 15.9913 14.8824 15.9589C13.8102 15.8562 12.7977 15.5535 11.849 15.0356C11.5161 14.8539 11.206 14.6352 10.9066 14.4028C10.752 14.2828 10.612 14.1195 10.4354 14.0366Z"
      fill="#34A853"
    />
  </ChakraIcon>
);

const AdformIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3345 12.3018C9.24774 12.3018 8.34649 11.5079 8.17871 10.4685C8.33518 9.49993 9.12852 8.7448 10.1154 8.64642C9.15493 9.0776 8.62151 10.1535 8.90275 11.2032C9.07641 11.8511 9.66364 12.3018 10.3345 12.3018Z"
      fill="#65C99C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1156 8.64647C10.1877 8.63933 10.2608 8.63563 10.3348 8.63563C10.561 8.63563 10.7858 8.67079 11.0012 8.73972C10.8674 9.12184 10.6763 9.36506 10.4897 9.34537C10.4382 9.34005 10.3865 9.33729 10.3348 9.33729C9.51616 9.33729 8.85256 10.0009 8.85256 10.8195C8.85256 10.9336 8.86544 11.0446 8.88986 11.1514C8.63949 10.1183 9.17102 9.07062 10.1156 8.64647Z"
      fill="#E7D94C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3271 9.71791C11.1878 9.59241 11.2406 9.2877 11.4349 8.93256C12.1064 9.32379 12.5193 10.0424 12.5193 10.8195C12.5193 12.0256 11.5415 13.0034 10.3353 13.0034C9.12919 13.0034 8.15137 12.0256 8.15137 10.8195C8.15137 10.7 8.16112 10.5829 8.17958 10.4686C8.34743 11.5079 9.24865 12.3017 10.3353 12.3017C11.154 12.3017 11.8176 11.6381 11.8176 10.8195C11.8176 10.3994 11.6393 9.99902 11.3271 9.71791Z"
      fill="#397FC4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6942 9.42789C14.5945 9.37021 14.4788 9.33722 14.3553 9.33722C13.9809 9.33722 13.6777 9.64068 13.6777 10.0148V12.7821H12.976V10.0148C12.976 9.25316 13.5937 8.63556 14.3553 8.63556C14.6065 8.63556 14.8421 8.70277 15.045 8.82016L14.6942 9.42789ZM17.4405 9.09575C17.693 8.81331 18.0603 8.63556 18.4689 8.63556C19.2304 8.63556 19.8481 9.25331 19.8481 10.0148V12.7821H19.1464V10.0148C19.1464 9.64053 18.8432 9.33722 18.4689 9.33722C18.0946 9.33722 17.7913 9.64068 17.7913 10.0148V12.7821H17.0896V10.0148C17.0896 9.64053 16.7864 9.33722 16.4121 9.33722C16.0378 9.33722 15.7346 9.64068 15.7346 10.0148V12.7821H15.0328V10.0148C15.0328 9.25316 15.6505 8.63556 16.4121 8.63556C16.8207 8.63556 17.1879 8.81331 17.4405 9.09575ZM8.59207 7.78863C8.49239 7.73096 8.37667 7.69802 8.25321 7.69802C7.87888 7.69802 7.57565 8.0013 7.57565 8.37559V8.72765H8.31313L8.00115 9.42784H7.57565V12.7821H6.87388V8.37559C6.87388 7.61396 7.49158 6.9963 8.25321 6.9963C8.50444 6.9963 8.73997 7.06361 8.94288 7.18101L8.65574 7.82542L8.59207 7.78863ZM0.381122 9.21724C0.634413 8.86724 1.07478 8.63556 1.57584 8.63556C2.3613 8.63556 2.99795 9.20487 2.99795 9.90713L2.99657 11.7319C2.99657 12.4341 2.35991 13.0034 1.57445 13.0034C0.78901 13.0034 0.152344 12.4341 0.152344 11.7319C0.152344 11.1437 0.561194 10.6334 1.24305 10.4507L2.2963 10.1685L2.29768 9.90713C2.29768 9.59236 1.97454 9.33722 1.57593 9.33722C1.33666 9.33722 1.1246 9.42917 0.993296 9.57071L0.918971 9.65285L0.381122 9.21724ZM2.2963 10.8957L2.29621 11.7319C2.29619 12.0465 1.97307 12.3017 1.57445 12.3017C1.17584 12.3017 0.85271 12.0466 0.85271 11.7319C0.85271 11.4626 1.09827 11.2171 1.42093 11.1306L2.2963 10.8957ZM5.5983 7.21769V8.81134C5.38671 8.69964 5.13995 8.63556 4.87646 8.63556C4.091 8.63556 3.45435 9.20487 3.45435 9.90713V11.7319C3.45435 12.4341 4.091 13.0034 4.87646 13.0034C5.66191 13.0034 6.29858 12.4341 6.29858 11.7319V7.21769H5.5983ZM5.5983 9.90713V11.7319C5.5983 12.0466 5.27518 12.3017 4.87655 12.3017C4.47793 12.3017 4.15481 12.0466 4.15481 11.7319V9.90713C4.15481 9.59236 4.47793 9.33722 4.87655 9.33722C5.27518 9.33722 5.5983 9.59236 5.5983 9.90713Z"
      fill="#6C6D70"
    />
  </ChakraIcon>
);

const PencilIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M15.0007 8.33424L11.6673 5.0009M2.08398 17.9176L4.90429 17.6042C5.24887 17.5659 5.42115 17.5468 5.58219 17.4946C5.72506 17.4484 5.86102 17.383 5.98639 17.3004C6.1277 17.2072 6.25027 17.0846 6.49542 16.8395L17.5007 5.83424C18.4211 4.91376 18.4211 3.42138 17.5007 2.5009C16.5802 1.58043 15.0878 1.58043 14.1673 2.5009L3.16209 13.5061C2.91694 13.7513 2.79436 13.8739 2.70118 14.0152C2.61851 14.1405 2.55316 14.2765 2.50691 14.4194C2.45478 14.5804 2.43564 14.7527 2.39735 15.0973L2.08398 17.9176Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const SpeakerIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 20 20" fill="none" {...props}>
    <g clipPath="url(#clip0_3378_23729)">
      <path
        d="M15 6.66602C15.663 6.66602 16.2989 6.92941 16.7678 7.39825C17.2366 7.86709 17.5 8.50297 17.5 9.16602C17.5 9.82906 17.2366 10.4649 16.7678 10.9338C16.2989 11.4026 15.663 11.666 15 11.666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33398 6.66602V15.8327C8.33398 16.0537 8.24619 16.2657 8.08991 16.4219C7.93363 16.5782 7.72166 16.666 7.50065 16.666H6.66732C6.4463 16.666 6.23434 16.5782 6.07806 16.4219C5.92178 16.2657 5.83398 16.0537 5.83398 15.8327V11.666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.66695L13.77 3.52528C13.8795 3.43404 14.0128 3.37591 14.1542 3.3577C14.2956 3.3395 14.4393 3.36197 14.5684 3.42249C14.6975 3.48301 14.8066 3.57907 14.8831 3.69941C14.9595 3.81975 15.0001 3.95938 15 4.10195V14.2319C15.0001 14.3745 14.9595 14.5142 14.8831 14.6345C14.8066 14.7548 14.6975 14.8509 14.5684 14.9114C14.4393 14.9719 14.2956 14.9944 14.1542 14.9762C14.0128 14.958 13.8795 14.8999 13.77 14.8086L10 11.6669H3.33333C3.11232 11.6669 2.90036 11.5792 2.74408 11.4229C2.5878 11.2666 2.5 11.0546 2.5 10.8336V7.50028C2.5 7.27927 2.5878 7.06731 2.74408 6.91103C2.90036 6.75475 3.11232 6.66695 3.33333 6.66695H10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3378_23729">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

const CommentIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M0.625 11.3058L1.49167 8.70581C-0.0576664 6.41447 0.541 3.4578 2.89167 1.7898C5.24233 0.122471 8.61833 0.259138 10.7883 2.1098C12.9583 3.96114 13.2517 6.95381 11.4743 9.11047C9.697 11.2671 6.39767 11.9205 3.75833 10.6391L0.625 11.3058Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChakraIcon>
);

const ExpandIcon: React.FC<ChakraIconProps> = (props) => (
  <ChakraIcon viewBox="0 0 20 20" fill="none" {...props}>
    <g clipPath="url(#clip0_3059_25033)">
      <path
        d="M13.333 3.33398H16.6663V6.66732"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 8.33398L16.667 3.33398"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66634 16.6673H3.33301V13.334"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33301 16.666L8.33301 11.666"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3059_25033">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);

export type AvailableIcon =
  | 'triangle-up'
  | 'triangle-down'
  | 'warning'
  | 'aiDoc'
  | 'download'
  | 'check'
  | 'close'
  | 'search'
  | 'overview'
  | 'lock'
  | 'unlock'
  | 'mmm'
  | 'mmm-performance'
  | 'mmm-created-value'
  | 'mmm-cost-per-unit'
  | 'mmm-modelling'
  | 'da'
  | 'da-explorer'
  | 'da-deep-dive'
  | 'da-channels'
  | 'da-search'
  | 'mo'
  | 'lt'
  | 'sos'
  | 'sos-municipality'
  | 'external-link'
  | 'ai'
  | 'location'
  | 'gear'
  | 'info'
  | 'circle-checkbox'
  | 'graph'
  | 'growth'
  | 'media'
  | 'refresh'
  | 'upload'
  | 'mail'
  | 'logo'
  | 'login'
  | 'x'
  | 'hamburger'
  | 'info'
  | 'plus'
  | 'graduation-cap'
  | 'credit-card'
  | 'filters'
  | 'users'
  | 'puzzle'
  | 'document-question'
  | 'excel'
  | 'trash'
  | 'facebook'
  | 'instagram'
  | 'google-ads'
  | 'youtube'
  | 'amplitude'
  | 'hubspot'
  | 'google-drive'
  | 'linkedin'
  | 'google-analytics'
  | 'salesforce'
  | 'stripe'
  | 'chevron-right'
  | 'chevron-down'
  | 'chevron-up'
  | 'minimize'
  | 'display'
  | 'could-ai'
  | 'scenario'
  | 'calendar'
  | 'report'
  | 'brain'
  | 'scale'
  | 'link'
  | 'mail-up'
  | 'minus'
  | 'sort'
  | 'sort-up'
  | 'sort-down'
  | 'mmm-updated'
  | 'marketing-optimization'
  | 'long-term-effect'
  | 'inbox'
  | 'goals-and-targets'
  | 'digital-insights'
  | 'connect'
  | 'settings'
  | 'user-add'
  | 'upload-data'
  | 'database'
  | 'logout'
  | 'hand-with-coin'
  | 'finger-on-dollar'
  | 'server'
  | 'arrow-diagonal-down'
  | 'arrow-diagonal-up'
  | 'tag'
  | 'arrow-graph'
  | 'arrow-switch'
  | 'sparkle'
  | 'dv360'
  | 'pinterest'
  | 'tiktok'
  | 'snapchat'
  | 'cv360'
  | 'x-logo'
  | 'adform'
  | 'shopify'
  | 'pencil'
  | 'view'
  | 'view-off'
  | 'speaker'
  | 'comment'
  | 'comments'
  | 'arrow-back'
  | 'delete'
  | 'chevron-left'
  | 'info-filled'
  | 'expand';

export type IconProps = ChakraIconProps & {
  iconName: AvailableIcon;
};

const getIcon = (iconName: AvailableIcon): React.FC<ChakraIconProps> => {
  switch (iconName) {
    case 'triangle-up':
      return TriangleUpIcon;
    case 'triangle-down':
      return TriangleDownIcon;
    case 'warning':
      return WarningIcon;
    case 'download':
      return DownloadIcon;
    case 'arrow-graph':
      return ArrowGraphIcon;
    case 'arrow-switch':
      return ArrowSwitchIcon;
    case 'sparkle':
      return SparkleIcon;
    case 'logout':
      return LogoutIcon;
    case 'hand-with-coin':
      return HandWithCoinIcon;
    case 'finger-on-dollar':
      return FingerOnDollarIcon;
    case 'server':
      return ServerIcon;
    case 'tag':
      return TagIcon;
    case 'pencil':
      return PencilIcon;
    case 'comment':
      return CommentIcon;
    case 'expand':
      return ExpandIcon;
    case 'database':
      return DatabaseIcon;
    case 'check':
      return CheckIcon;
    case 'close':
      return CloseIcon;
    case 'search':
      return SearchIcon;
    case 'lock':
      return LockIcon;
    case 'unlock':
      return UnlockIcon;
    case 'overview':
      return OverviewIcon;
    case 'mmm':
      return MMMIcon;
    case 'mmm-performance':
      return MMMPerformanceIcon;
    case 'mmm-created-value':
      return MMMCreatedValueIcon;
    case 'mmm-cost-per-unit':
      return MMMCostPerUnitIcon;
    case 'mmm-modelling':
      return MMMModellingIcon;
    case 'da':
      return DAIcon;
    case 'da-explorer':
      return DAExplorerIcon;
    case 'da-deep-dive':
      return DADeepDiveIcon;
    case 'da-channels':
      return DAChannelsIcon;
    case 'da-search':
      return DASearchIcon;
    case 'mo':
      return MOIcon;
    case 'lt':
      return LtIcon;
    case 'sos':
      return SOSIcon;
    case 'sos-municipality':
      return SOSMunicipalityIcon;
    case 'external-link':
      return ExternalLinkIcon;
    case 'info':
      return InfoOutlineIcon;
    case 'ai':
      return AiIcon;
    case 'location':
      return LocationIcon;
    case 'gear':
      return GearIcon;
    case 'aiDoc':
      return AiDocIcon;
    case 'circle-checkbox':
      return CircleCheckbox;
    case 'graph':
      return GraphIcon;
    case 'growth':
      return GrowthIcon;
    case 'media':
      return MediaIcon;
    case 'refresh':
      return RefreshIcon;
    case 'upload':
      return UploadIcon;
    case 'login':
      return LoginIcon;
    case 'hamburger':
      return HamburgerIcon;
    case 'mail':
      return MailIcon;
    case 'logo':
      return LogoIcon;
    case 'x':
      return XIcon;
    case 'plus':
      return PlusIcon;
    case 'graduation-cap':
      return GraduationCapIcon;
    case 'credit-card':
      return CreditCardIcon;
    case 'filters':
      return FiltersIcon;
    case 'users':
      return UsersIcon;
    case 'puzzle':
      return PuzzleIcon;
    case 'document-question':
      return DocumentQuestionIcon;
    case 'excel':
      return ExcelIcon;
    case 'trash':
      return TrashIcon;
    case 'info-filled':
      return InfoIcon;
    case 'facebook':
      return FacebookIcon;
    case 'google-ads':
      return GoogleAdsIcon;
    case 'youtube':
      return YouTubeIcon;
    case 'instagram':
      return InstagramIcon;
    case 'amplitude':
      return AmplitudeIcon;
    case 'hubspot':
      return HubspotIcon;
    case 'google-drive':
      return GoogleDriveIcon;
    case 'linkedin':
      return LinkedInIcon;
    case 'google-analytics':
      return GoogleAnalyticsIcon;
    case 'salesforce':
      return SalesforceIcon;
    case 'stripe':
      return StripeIcon;
    case 'chevron-right':
      return ChevronRightIcon;
    case 'chevron-down':
      return ChevronDownIcon;
    case 'chevron-up':
      return ChevronUpIcon;
    case 'minimize':
      return MinimizeIcon;
    case 'display':
      return DisplayIcon;
    case 'could-ai':
      return CouldAiIcon;
    case 'scenario':
      return ScenarioIcon;
    case 'calendar':
      return CalendarIcon;
    case 'report':
      return ReportIcon;
    case 'brain':
      return BrainIcon;
    case 'scale':
      return ScaleIcon;
    case 'link':
      return LinkIcon;
    case 'mail-up':
      return MailUpIcon;
    case 'minus':
      return MinusIcon;
    case 'sort':
      return SortIcon;
    case 'sort-up':
      return SortUpIcon;
    case 'sort-down':
      return SortDownIcon;
    case 'mmm-updated':
      return MMMUpdated;
    case 'marketing-optimization':
      return MarketingOptimization;
    case 'long-term-effect':
      return ClipboardIcon;
    case 'inbox':
      return InboxIcon;
    case 'goals-and-targets':
      return GoalsAndTargetsIcon;
    case 'digital-insights':
      return DigitalInsightsIcon;
    case 'settings':
      return SettingsIcon;
    case 'connect':
      return ConnectIcon;
    case 'user-add':
      return UserAddIcon;
    case 'upload-data':
      return UploadDataIcon;
    case 'arrow-diagonal-down':
      return ArrowDiagonalDownIcon;
    case 'arrow-diagonal-up':
      return ArrowDiagonalUpIcon;
    case 'tiktok':
      return TiktokIcon;
    case 'dv360':
      return Dv360Icon;
    case 'pinterest':
      return PinterestIcon;
    case 'snapchat':
      return SnapchatIcon;
    case 'cv360':
      return Cv360Icon;
    case 'x-logo':
      return XLogoIcon;
    case 'adform':
      return AdformIcon;
    case 'shopify':
      return ShopifyIcon;
    case 'view':
      return ViewIcon;
    case 'view-off':
      return ViewOffIcon;
    case 'speaker':
      return SpeakerIcon;
    case 'arrow-back':
      return ArrowBackIcon;
    case 'delete':
      return DeleteIcon;
    case 'chevron-left':
      return ChevronLeftIcon;
    case 'comments':
      return ChatIcon;
  }
};

export const Icon: React.FC<IconProps> = ({ iconName, ...chakraIconProps }) => {
  const IconComponent = getIcon(iconName);

  return <IconComponent {...chakraIconProps} />;
};
